<div class="row mb-2" *ngIf="!global.docbool">
  <div class="col p-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-header transparent  text-muted">
        <div class="row col-12">
          <div class="col-8">
            <span>
              <h4 *ngIf="DataFromList.newclient" class="mb-0 font-header">New Client</h4>
              <h4 *ngIf="!DataFromList.newclient" class="mb-0 font-header">Update Client</h4>
            </span>
          </div>

          <div class="col-2">

            <button class="btn  btn-sm text-end ms-1 " type="button"
              *ngIf="ClientList.id=='00000000-0000-0000-0000-000000000000' "
              [disabled]="
                            ClientList.dOB==undefined || ClientList.dOB==null || ClientList.dOB==''||
                               ClientDataForm.controls['ClientEmail'].touched && ClientDataForm.controls['ClientEmail'].invalid" tabindex="22"
              (click)="SaveorUpdateClient(ClientList)">Save</button>

            <button class="btn  btn-sm text-center ms-1 " type="button" *ngIf="isEditBoolean" [disabled]="!fp.clientupdate" 
              (click)="EditClientDetails()">Edit</button>


            <button class="btn  btn-sm text-center ms-1 " type="button" *ngIf="isViewUpdate"
              [disabled]="ClientList.dOB==undefined || ClientList.dOB==null || ClientList.dOB==''||  
                             ClientDataForm.controls['ClientEmail'].touched && ClientDataForm.controls['ClientEmail'].invalid" (click)="SaveorUpdateClient(ClientList)" tabindex="22">Update
            </button>


            <button class="btn  btn-sm text-left ms-3" type="button" (click)="clientvaluechange()"
              tabindex="22">Close</button>

          </div>

          <div class="col-2 text-right">
            <label class="notealert">Note: * fields are mandatory</label>
          </div>
        </div>
      </div>
      <!--------------------------------------Card body starts here----------------->
      <div class="card-body pb-0 pt mb-4">

        <!-- <div class="row">
                    <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-2">
                                <label class="label-bold ">Status</label>&nbsp;
                            </div>
                            <div class="col-lg-8">
                                <ng-select class="w-100" [(ngModel)]="ClientList.statusLid" [searchable]="true"
                                    [clearable]="true" [items]="statusList" bindLabel="lovName"
                                    [disabled]="global.viewTabs" bindValue="id">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                  

                    <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-2">
                                <label class="label-bold ">Location</label>&nbsp;&nbsp;
                            </div>
                            <div class="col-lg-8">
                                <ng-select class="w-100 col-lg-5" [(ngModel)]="ClientList.locationId"
                                    [searchable]="true" [clearable]="true" [items]="getLocationList" bindLabel="Value"
                                    [disabled]="global.viewTabs" bindValue="Key">
                                </ng-select>
                            </div>

                        </div>

                    </div>

                </div> -->

        <!-----------------------------Info starts-------------------------------->
        <div class="row mb-2">
          <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
              <div class="card-header transparent  text-muted">
                <div class="row">

                  <div class="col-lg-4 divider">
                    <!-- <div class="divider"> -->
                    <div class="row mt-2 ml-1 mr-1">
                      <div class="col">
                        <div class="row">

                          <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="row">
                              <div class="col-lg-5 col-sm-6 col-md-6 form-group ">
                                <ng-select class="w-100" [(ngModel)]="ClientList.statusLid" [searchable]="true"
                                  [clearable]="true" [items]="statusList" bindLabel="lovName"
                                  [disabled]="isgeneraltabfieldview" bindValue="id">
                                </ng-select>
                              </div>
                              <div class="col-lg-5 col-sm-6 col-md-6 form-group d-inline-flex">
                                <ng-select class="w-100 col-lg-5" [(ngModel)]="ClientList.locationId"
                                  [searchable]="true" [clearable]="true" [items]="getLocationList" bindLabel="Value"
                                  [disabled]="isgeneraltabfieldview" bindValue="Key">
                                </ng-select>
                                <app-dropdown class="ms-1" *ngIf="!isFieldEnabled"
                                  (EmitRefreshClick)="refreshToGetDropDownValues('LOCATION_STATUS')"></app-dropdown>
                              </div>
                            </div>
                          </div>
                          <!-- client name -->
                          <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="row">
                              <div class="col-lg-8 col-md-8 col-sm-8">
                                <label data-bs-toggle="modal" data-bs-target="#showPopup" placement="right"
                                  class="mr-1 label-bold ">{{ClientList.lastName}} , &nbsp;{{ClientList.firstName}}&nbsp;{{ClientList.middleName}}</label>
                              </div>
                            </div>

                          </div>

                        </div>


                        <!-- dob -->
                        <div class="row">
                          <div class="col-lg-8 col-md-8">
                            <label class="mr-1 label-bold ">DOB</label> &nbsp; <label
                              class="mr-1 label-bold">{{ClientList.dOB}}</label>
                          </div>
                        </div>
                        
                                                <div class="row mt-1">
                                                  <div class="col-lg-2 col-md-5 col-xs-5 mt-1 buttonpaddinglr" style="padding-left: 9px;">
                                                    <label class="label-bold">Monitor</label>
                        
                                                  </div>
                        
                                                  <div class="col-lg-1 col-md-5 col-xs-5 mt-1 buttonpaddinglr" style=" padding-top:6px">
                        
                                                    <div class="custom-toggle-container">
                                                      <input type="checkbox" id="custom-toggle" [(ngModel)]="ClientList.isMonitor"
                                                        (ngModelChange)="openemitMonitorModal()"
                                                        [disabled]="isgeneraltabfieldview|| ClientList.id=='00000000-0000-0000-0000-000000000000'||ClientList.id==undefined||ClientList.id==null" />
                                                      <label for="custom-toggle" class="custom-toggle-label">
                                                        <span class="custom-toggle-slider"></span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <div class="col-lg-2 col-md-5 col-xs-5 mt-3" *ngIf="ClientList.isMonitor">
                                                    <button class="border-0 bg-transparent" type="button"
                                                      [disabled]="isgeneraltabfieldview || ClientList.id=='00000000-0000-0000-0000-000000000000'||ClientList.id==undefined||ClientList.id==null"
                                                      (click)="openemitMonitorModal()">
                                                      <i class="fa fa-edit "  style="color:#00786a; font-size:15px;"></i></button>
                                                  </div>
                                                  <!-- <p>Toggle is: {{ ClientList.isMonitor ? 'ON' : 'OFF' }}</p> -->
                        
                        
                                                </div>
                        <!-- Eligibility -->
                        <div class="row">
                          <div class="col-lg-2 col-md-3">
                            <label class="mr-1 label-bold ">Eligibility</label>
                          </div>
                          <div class="col-lg-8 col-md-8 col-sm-8">
                            <button type="button"
                              [style.backgroundColor]="(ClientList.isMAEligible=='Yes')?'green':'red'"
                              id="ClientEditEligible" style="color: white;" class="btn  btn-sm mb-1"
                              [disabled]="isFieldEnabled">Eligible</button>&nbsp;
                            <button type="button" id="ClientEditWaiver"
                              [style.backgroundColor]="(ClientList.waiver != null &&ClientList.waiver != '' )?'green':'red'"
                              style="color: white;" class="btn  btn-sm mb-1 ml-1"
                              [disabled]="isFieldEnabled">Waiver</button>
                            &nbsp;
                            <button type="button" id="ClientEditSpendDown"
                              [style.backgroundColor]="(this.ClientList.spendDown=='Yes')?'green':'red'"
                              style="color: white;" class="btn  btn-sm mb-1 ml-1"
                              [disabled]="isFieldEnabled">SpendDown</button>
                          </div>
                          <ng-container *ngIf="ClientList.program=='MA12'">
                            <div class="col-lg-3 col-md-2" *ngIf="ClientList.pmap!=null && ClientList.pmap!=undefined &&
                ClientList.pmap!=''">
                              <label>{{ClientList.pmap}}</label>

                            </div>
                          </ng-container>
                          <div class="col-lg-2 col-md-2" *ngIf="ClientList.waiver!=null && ClientList.waiver!=undefined &&
                ClientList.waiver!=''">
                  <label>{{ClientList.waiver}}</label>
                </div>
              </div>
              <!--  Medicaid -->
              <div class="row">
                <div class="col-lg-4 col-md-5 col-sm-5">
                  <label class="mr-1 label-bold ">Medicaid</label>
                </div>
                <div class="col-lg-6 col-md-5 col-sm-5">
                  <label class="mr-1 label-bold " style="width:100px">{{ClientList.medicaid}}</label>
                </div>
              </div>
               <!-- Client Type  -->
               <div class="row">
                <div class="col-lg-4 col-md-5 col-sm-5">
                  <label class="mr-1 label-bold ">Client Type</label>
                </div>
                <div class="col-lg-6 col-md-5 col-sm-5">
                  <ng-select class="w-100"[ngModelOptions]="{standalone: true}" [(ngModel)]="ClientList.clientTypeLid" 
                  id="ClientEditclientTypeLid1" (change)="LanguageChange($event)" bindLabel="lovName"  bindValue="id"  [items]="TypeofClient"
                     [disabled]="true" [ngModelOptions]="{standalone: true}" 
                    >
                    </ng-select>
                  </div>
               </div>
                        
                        <!-- /////////////////////////for mobile size ///////////////////////////////////////////////////////////-->
                        <!-- Office Case Manager -->
                         
                        <div class="row mt-1 ml-0 d-lg-none"
                          *ngIf="global.clientId!=00000000-0000-0000-0000-000000000000">
                          <button class="btn blue-btn btn-sm ml-2" data-bs-toggle="modal"
                            data-bs-target="#officecaseManagerView">Office
                            Case
                            Manager</button>
                        </div>

                        <!-- Emergency Contact -->
                        <div class="row mt-1 ml-0 d-lg-none"
                          *ngIf="global.clientId!=00000000-0000-0000-0000-000000000000">
                          <button class="btn blue-btn btn-sm ml-2" data-bs-toggle="modal"
                            data-bs-target="#emergencyContactView">Emergency Contact</button>
                        </div>
                        <!-- Responsible party -->
                        <div class="row mt-1 ml-0 d-lg-none ms-2"
                          *ngIf="global.clientId!=00000000-0000-0000-0000-000000000000">
                          <button class="btn blue-btn btn-sm ml-2" data-bs-toggle="modal"
                            data-bs-target="#responsiblepartyConView">Participant's Representative</button>
                        </div>
                        <div class="row mt-1 ml-0 d-lg-none ms-2"
                          *ngIf="global.clientId!=00000000-0000-0000-0000-000000000000">
                          <button class="btn blue-btn btn-sm ml-2" data-bs-toggle="modal"
                            data-bs-target="#missingdocument">Missing Document</button>
                        </div>
                       
    
                          <!-- <div class="col-lg-6 col-md-5 col-sm-5">
                            <label class="mr-1 label-bold ">Client Type</label>
                          </div>
                          <div class="col-lg-6 col-md-5 col-sm-5">
                            <ng-select class="w-100"[ngModelOptions]="{standalone: true}" [(ngModel)]="ClientList.clientTypeLid" 
                            id="ClientEditclientTypeLid1" (change)="LanguageChange($event)" bindLabel="lovName"  bindValue="id"  [items]="TypeofClient"
                               [disabled]="true" [ngModelOptions]="{standalone: true}" 
                              >
                              </ng-select>
                            </div> -->


                      </div>
                    </div>
                  </div>
                  <!-- /////////////////////////////////////////////////////////// for large Size /////////////////////////////////////////////////////////-->

                  <div class="col-lg-2 divider d-none d-lg-block sidebar-scroll">
                    <div>
                      <div class="row   mt-1 mb-1">
                        <div class="col-lg-12 col-md-12">
                          <div class="row" style="border-bottom:1px solid grey">
                            <h6 class="headerInfo-label ms-1">Office Case Manager</h6>
                          </div> <!-- Case Manager: --> <label class="font-header mt-3"
                            style="font-weight: bold;color: black;">Case Manager:</label>
                          <div class="row" *ngFor="let st of clientcasemanagerandContactDetail?.caseManagers"   >
                            <div class="col-lg-12">
                              <label class="font-header" 
                              data-bs-target="#showOfficeCaseManagerDetails" data-bs-toggle="modal"
                                (click)="OfficeCaseManagerdetails(st)">{{st.name}}</label>
                            </div>
                            <div class="col-lg-12">
                              <label class="font-header">{{ st.activeDate }}</label>
                            </div>
                            <div class="col-lg-12">
                              <label class="font-header">{{st.phone}}</label>
                            </div>
                          </div>
                          <!-- Coordinators: -->
                          <label class="font-header mt-3" style="font-weight: bold;color: black;">Coordinators:</label>
                          <div class="row" *ngFor="let CM of clientcasemanagerandContactDetail?.careCoordinators" 
                          >
                            <div class="col-lg-12">
                              <label class="font-header" data-bs-toggle="modal" data-bs-target="#showCareCoordinatorDetails"
                                (click)="OfficeCareCoordinatordetails(CM)">{{CM.coordinator_Name}}</label>
                            </div>
                            <div class="col-lg-12">
                              <label class="font-header">{{ CM.activeDate }}</label>
                            </div>
                            <div class="col-lg-12">
                              <label class="font-header">{{CM.phoneNumber}}</label>
                            </div>
                          </div>
                          <!-- Employee: -->
                          <br>
                          <label class="font-header mt-3" style="font-weight: bold;color: black;">Employee:</label>
                          <i class="fa fa-plus-circle" aria-hidden="true"
                          [ngClass]="{ 'icon-disabled': isFieldEnabled }" style="color:#00786a;font-size: 22px;" (click)="openClientEmployeeMapping()"
                          [disabled]="!ClientList.id || ClientList.id === '00000000-0000-0000-0000-000000000000'" [disabled]="isFieldEnabled"></i>
                          <div class="row" *ngFor="let qp of clientcasemanagerandContactDetail?.employeeClientMappings">
                            <div class="col-lg-12">
                              <label class="font-header" data-bs-toggle="modal" data-bs-target="#showQpDetails"
                                (click)="Qpdetails(qp)" [style.Color]="qp.age > 18 ? '' : 'red' ">{{qp.name}}
                                <span>-</span> {{qp?.activeDate}}</label>
                            </div>
                          </div>
                          <br><label class="font-header mt-3" style="font-weight: bold;color: black;">Employee
                            History:</label>
                          <div class="row" *ngFor="let qphistory of clientcasemanagerandContactDetail?.echistory">
                            <div class="col-lg-12"> <label class="font-header" data-bs-toggle="modal"
                                data-bs-target="#showQPHistoryDetails"
                                (click)="QPHistorydetails(qphistory)">{{qphistory.name}}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="col-lg-3 divider d-none d-lg-block sidebar-scroll">
                    <div class="row ml-1 mr-1 mt-1 mb-1">
                      <div class="col-lg-12 col-md-12">
                        <div class="row" style="border-bottom:1px solid grey">
                          <h6 class="headerInfo-label">Emergency Contact</h6>
                        </div>
                        <div class="row ms-1 mt-2" *ngFor="let st of clientcasemanagerandContactDetail?.emergencyContacts">
                          <div class="col-lg-12 p-0">
                            <label class="font-header m-0" style="margin-left: 2px;" data-bs-toggle="modal"
                              data-bs-target="#showEmergencyContactDetails"
                              (click)="EmergencyContactdetails(st)">{{st.name}}<span
                                *ngIf="st.relationship !=null">({{st.relationship}})</span></label>
                          </div>
                          <div class="col-lg-12 p-0">
                            <label class="font-header" style="margin-left: 2px;">{{st.phoneNumber}}</label>
                          </div>
                        </div>
                         <!-- fmsagency: -->
                          <label class="font-header mt-3" style="font-weight: bold;color: black;">FMS Agency:</label>
                          <div class="row" *ngFor="let CM of clientcasemanagerandContactDetail?.fmsAgency" 
                          >
                            <div class="col-lg-12">
                              <label class="font-header" data-bs-toggle="modal" data-bs-target="#showfmsagencyDetails"
                                (click)="Officefmsagencydetails(CM)">{{CM.providerName}}</label>
                            </div>
                            <div class="col-lg-12">
                              <label class="font-header">{{ CM.activeDate }}</label>
                            </div>
                            <div class="col-lg-12">
                              <label class="font-header">{{CM.phoneNumber}}</label>
                            </div>
                          </div>
                        <br>
                           <!-- hhaagency: -->
                          <label class="font-header mt-3" style="font-weight: bold;color: black;">Home Health Agency:</label>
                          <div class="row" *ngFor="let CM of clientcasemanagerandContactDetail?.hhAgency" 
                          >
                            <div class="col-lg-12">
                              <label class="font-header" data-bs-toggle="modal" data-bs-target="#showhhaagencyDetails"
                                (click)="Officehhaagencydetails(CM)">{{CM.hhaName}}</label>
                            </div>
                            <div class="col-lg-12">
                              <label class="font-header">{{ CM.activeDate }}</label>
                            </div>
                            <div class="col-lg-12">
                              <label class="font-header">{{CM.phoneNumber}}</label>
                            </div>
                          </div>
<!-- <div class="row mb-2" *ngIf="!DataFromList.newclient">
  <div class="col p-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body">
        <button 
          type="button" 
          class="btn btn-primary btn-sm" 
          (click)="openClientEmployeeMapping()"
          [disabled]="!ClientList.id || ClientList.id === '00000000-0000-0000-0000-000000000000'" [disabled]="isFieldEnabled">
          Client Employee Mapping
        </button>
      </div>
    </div>
  </div>
</div> -->

                      </div>
                    </div>

                  </div>
                  <div class="col-lg-3  divider d-none d-lg-block sidebar-scroll">
                    <div class="row ml-1 mr-1 mt-1">
                      <div class="col-lg-12 col-md-12">
                        <div class="row" style="border-bottom:1px solid grey">
                          <h6 class="headerInfo-label">Participant's Representative</h6>
                        </div>
                        <div class="row ms-1 mt-2" *ngFor="let st of clientcasemanagerandContactDetail?.participantsRepresentativeContacts">
                          <div class="col-lg-12 p-0">
                            <label class="font-header m-0 " style="margin-left: 2px;" data-bs-toggle="modal"
                              data-bs-target="#showResponsiblePartyDetails"
                              (click)="Responsiblepartydetails(st)">{{st.name}}<span
                                *ngIf="st.relationship !=null">({{st.relationship}})</span></label>
                          </div>
                          <div class="col-lg-12 p-0">
                            <label class="font-header" style="margin-left: 2px;">{{st.phoneNumber}}</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row ml-1 mr-1 mt-4">
                      <div class="col-lg-12 col-md-12">
                        <div class="row " style="border-bottom:1px solid grey">
                          <h6 class="headerInfo-label">Missing Documents</h6>
                        </div>
                        <div class="row ms-1 mt-2" *ngFor="let st of clientcasemanagerandContactDetail?.requiredDocuments;let i = index">
                          <div class="col-lg-12 p-0">
                            <label class="font-header m-0" style="margin-left: 2px;" data-bs-toggle="modal"
                              data-bs-target="#missingdocument"
                              >{{i+1}}. {{st}}</label>
                          </div>                  
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>



  <!-------------------------------  CLIENT TAB -------------------------------------------------->
  <div class="mt-2 p-0 mb-2">
    <div class="col p-0">
      <div widget class="card border-0 box-shadow" style="min-height: 500px;">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <nav *ngIf="!global.docbool">
              <div class="nav nav-tabs nav-fill " id="nav-tab" role="tablist">

                <!-- Notes -->
                <a class="nav-item nav-link " id="nav-notes-tab" data-bs-toggle="tab" href="#nav-notes" role="tab"
                  [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000' , 
                                    'mytab-inactive':ActiveTab!='nav-notes','active':ActiveTab=='nav-notes' }"
                  aria-controls="nav-notes" aria-selected="true"
                  (click)="getTabActiveData('nav-notes');isNotes=true">Notes</a>

                <a class="nav-item nav-link active" id="nav-general-tab" data-bs-toggle="tab" href="#nav-general"
                  role="tab"
                  [ngClass]="{'disabled':ClientList.id===''  , 'mytab-inactive':ActiveTab!='nav-general','active':ActiveTab=='nav-general' }"
                  aria-controls="nav-general" aria-selected="true" (click)="getTabActiveData('nav-general')">General</a>

                                    <a class="nav-item nav-link " id="nav-contacts-tab" data-bs-toggle="tab"
                                        href="#nav-contacts" role="tab"
                                        [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'  , 'mytab-inactive':ActiveTab!='nav-contacts','active':ActiveTab=='nav-contacts'}"
                                        aria-controls="nav-contacts" aria-selected="false"
                                        (click)="getTabActiveData('nav-contacts');isEnabledcontact=true">Contacts</a>
                                    <!-- Start Of Care Tab -->
                                <a class="nav-item nav-link " id="nav-soc-tab" data-bs-toggle="tab" 
                                    href="#nav-soc" role="tab"
                                    [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'  , 'mytab-inactive':ActiveTab!='nav-soc','active':ActiveTab=='nav-soc'}"
                                    aria-controls="nav-soc" aria-selected="false" 
                                    (click)="getTabActiveData('nav-soc')">
                                    Start of care</a>


                <a class="nav-item nav-link" id="nav-certification-tab" data-bs-toggle="tab" href="#nav-certification"
                  [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'   , 'mytab-inactive':ActiveTab!='nav-certification','active':ActiveTab=='nav-certification'}"
                  role="tab" aria-controls="nav-certification" aria-selected="false"
                  (click)="getTabActiveData('nav-certification')">Certification</a>

                <a class="nav-item nav-link " id="nav-authorization-tab" data-bs-toggle="tab" href="#nav-authorization"
                  [ngClass]="{'disabled':global.clientId==='00000000-0000-0000-0000-000000000000'  , 'mytab-inactive':ActiveTab!='nav-authorization','active':ActiveTab=='nav-authorization' }"
                  role="tab" aria-controls="nav-authorization" aria-selected="false"
                  (click)="getTabActiveData('nav-authorization')">Authorization</a>

                <a class="nav-item nav-link " id="nav-serviceplan-tab" data-bs-toggle="tab" href="#nav-serviceplan"
                  [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'   , 'mytab-inactive':ActiveTab!='nav-serviceplan','active':ActiveTab=='nav-serviceplan' }"
                  role="tab" aria-controls="nav-serviceplan" aria-selected="false"
                  (click)="getTabActiveData('nav-serviceplan')">Service Delivery Plan
                </a>
                <a class="nav-item nav-link " id="nav-consultation-tab" data-bs-toggle="tab" href="#nav-consultation"
                  [ngClass]="{'disabled':global.clientId==='00000000-0000-0000-0000-000000000000'  , 'mytab-inactive':ActiveTab!='nav-consultation','active':ActiveTab=='nav-consultation' }"
                  role="tab" aria-controls="nav-consultation" aria-selected="false"
                  (click)="getTabActiveData('nav-consultation');isconsultationform=true">Consultation
                  Session</a>

                <a class="nav-item nav-link " id="nav-documents-tab" data-bs-toggle="tab" href="#nav-documents"
                  [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'   , 'mytab-inactive':ActiveTab!='nav-documents','active':ActiveTab=='nav-documents' }"
                  role="tab" aria-controls="nav-documents" aria-selected="false"
                  (click)="getTabActiveData('nav-documents');isdynamicFormcontact=true;reDirect()">Dynamic
                  Client Form</a>

                <a class="nav-item nav-link " id="nav-document-tab" data-bs-toggle="tab" href="#nav-document"
                  [ngClass]="{'disabled':global.clientId==='00000000-0000-0000-0000-000000000000'  , 'mytab-inactive':ActiveTab!='nav-document','active':ActiveTab=='nav-document' }"
                  role="tab" aria-controls="nav-document" aria-selected="false"
                  (click)="getTabActiveData('nav-document');DocumentListbool=true">Document</a>
                <a *ngIf="fp?.customerSupport" class="nav-item nav-link " id="nav-document-tab" data-bs-toggle="tab" href="#nav-csengagement"
                  [ngClass]="{'disabled':global.clientId==='00000000-0000-0000-0000-000000000000'  , 'mytab-inactive':ActiveTab!='nav-csengagement','active':ActiveTab=='nav-csengagement' }"
                  (click)="getTabActiveData('nav-csengagement');">Customer Support</a>

                <!-- <a class="nav-item nav-link " id="nav-budget-tab" data-bs-toggle="tab" href="#nav-budget"
                  [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'   , 'mytab-inactive':ActiveTab!='nav-budget','active':ActiveTab=='nav-budget' }"
                  role="tab" aria-controls="nav-budget" aria-selected="false"
                  (click)="getTabActiveData('nav-budget')">Budget
                </a> -->

           

               






              </div>
            </nav>


            <div class="tab-content" id="nav-tabContent">



              <!--------------------------- General----------- ------------------->
              <div *ngIf="ActiveTab=='nav-general'">
                <div class="tab-pane fade  " id="nav-general" role="tabpanel" aria-labelledby="nav-general"
                  [ngClass]="{'active':ActiveTab=='nav-general','show':ActiveTab=='nav-general'}">
                  <div class="row mb-2">
                    <div class="col ps-0">

                      <!-- ------------General Info-------------------- -->
                      <div class="card-header transparent text-muted ms-2  me-3">
                        <div class="row">
                          <div class="col-lg-10">
                            <h5 class="mb-0 font-header">General Info</h5>
                          </div>

                          <!-- <div class="col-lg-4">
                            <button class="btn  btn-sm text-end ms-1 " type="button"
                            *ngIf="ClientList.id=='00000000-0000-0000-0000-000000000000' "
                            [disabled]="
                                          ClientList.dOB==undefined || ClientList.dOB==null || ClientList.dOB==''||
                                             ClientDataForm.controls['ClientEmail'].touched && ClientDataForm.controls['ClientEmail'].invalid" tabindex="22"
                            (click)="SaveorUpdateClient(ClientList)">Save</button>
              
                          <button class="btn  btn-sm text-center ms-1 " type="button" [disabled]="!fp.clientupdate" *ngIf="isEditgeneralBoolean "
                            (click)="EditClientgeneraltab()">Edit</button>
              
              
                          <button class="btn  btn-sm text-center ms-1 " type="button" *ngIf="isViewUpdate"
                            [disabled]="ClientList.dOB==undefined || ClientList.dOB==null || ClientList.dOB==''||  
                                           ClientDataForm.controls['ClientEmail'].touched && ClientDataForm.controls['ClientEmail'].invalid" (click)="SaveorUpdateClient(ClientList)" tabindex="22">Update
                          </button>
                          </div> -->

                        </div>
                      </div>

                      <div class="card-body widget-body pt-2 ms-2  me-3">
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="row" [formGroup]="ClientDataForm">
                              <div class="col-lg-6 col-md-6 d-inline-flex ">
                                <label class=" me-1 label-bold w-75">First Name<sup class="super-script">*</sup></label>
                                <input type="text" class="form-control w-100" name="firstName"
                                  [(ngModel)]="ClientList.firstName" formControlName="firstName" id="fname"
                                  (change)="changefunction()" />
                              </div>
                              <div class="col-lg-6 col-md-6 d-inline-flex ">
                                <label class=" me-1 label-bold  w-75">Middle
                                  Name</label>
                                <input type="text" class="form-control w-100" name="middleName"
                                  formControlName="middleName" [(ngModel)]="ClientList.middleName"
                                  (change)="changefunction()">
                              </div>
                            </div>
                            <div class="row mt-1" [formGroup]="ClientDataForm">
                              <div class="col-lg-6 col-md-6 d-inline-flex">
                                <label class=" me-1 label-bold  w-75">Last Name<sup class="super-script">*</sup></label>
                                <input type="text" class="form-control w-100" name="lastName"
                                  [(ngModel)]="ClientList.lastName" formControlName="lastName"
                                  (change)="changefunction()">
                              </div>

                              <div class="col-lg-6 col-md-6 d-inline-flex">
                                <label class="label-bold  w-75">DOB<sup class="super-script">*</sup></label>
                                <my-date-picker class="w-100" placeholder="mm/dd/yyyy" name="dOB" id="dob"
                                  [selDate]="ClientList.dOB" [options]="myDatePickerOptionsDOB"
                                  (inputFieldChanged)="DOBdatechange($event)"
                                  (dateChanged)="onDateChanged($event)" [disabled]="isgeneraltabfieldview"></my-date-picker>

                              </div>

                            </div>
                            <div class="row ">
                              <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ClientDataForm">
                                <label class="label-bold  w-75">Gender<sup class="super-script">*</sup></label>

                                <ng-select class="w-100 " [(ngModel)]="ClientList.genderLid" formControlName="genderLid"
                                  [searchable]="true" [clearable]="true" [items]="genderList" bindLabel="lovName"
                                  name="genderLid" bindValue="id" (change)="changefunction()">
                                </ng-select>
                              </div>
                              <div class="col-lg-6 col-md-6 d-inline-flex">
                                <label class="me-1 label-bold w-75">Age</label>
                                <input type="text" class="form-control w-100" name="age" [(ngModel)]="ClientList.age"
                                  disabled (change)="changefunction()">
                              </div>
                            </div>
                            <div class="row mt-1">
                              <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ClientDataForm">
                                <label class="me-1 label-bold w-75">Medicaid# (PMI)<sup class="super-script">*&nbsp;</sup>  
                                             <!-- <button type="button" class="btn blue-btn btn-sm" 
      [disabled]="!ClientList.medicaid || ClientList.medicaid.trim() === ''"
      (click)="checkForReferral()" 
      id="btnCheckReferral"
      style="width: 50%;">
      <span >Check for Referral</span>
      
    </button>-->
  </label> 
                    
                                <input type="text" class="form-control w-100" name="medicaid" [disabled]="isgeneraltabfieldview"
                                  [(ngModel)]="ClientList.medicaid" minlength="20"
                                  maxlength="20"  (blur)="checkForReferral()" (keypress)="keyPress($event)" (change)="changefunction()" 
                                  formControlName="medicaid" id="ClientEditmedicaid"/>
                              </div>
                              <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ClientDataForm">
                                <label class="me-1 label-bold w-75">Medicare#</label>
                                <input type="text" class="form-control w-100" name="medicare" [disabled]="isgeneraltabfieldview"
                                  [(ngModel)]="ClientList.medicare" minlength="20"
                                  maxlength="20" (keypress)="keyPress($event)" (change)="changefunction()" 
                                  formControlName="medicare" id="ClientEditmedicare"/>
                              </div>
                            </div>

                            <div class="row mt-1">
                              <div class="col-lg-6 col-md-6 d-inline-flex">
                                <label class=" label-bold w-75">Language</label>

                                <ng-select class="w-100" [(ngModel)]="selectedLanguages" [searchable]="true"
                                  [clearable]="true" [multiple]="true" [items]="languageList" bindLabel="languageName"
                                  bindValue="id" name="languageIds" (change)="LanguageChange($event)"
                                  [disabled]="isgeneraltabfieldview" (change)="changefunction()">

                                </ng-select>
                              </div>
                              <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ClientDataForm">
                                <label class=" label-bold w-75">Type of Waiver</label>

                                <ng-select class="w-100" [(ngModel)]="ClientList.typeofWaiverLid" [searchable]="true"
                                  [clearable]="true" [items]="TypeofWaiver" bindLabel="lovName" bindValue="id"
                                  [disabled]="isgeneraltabfieldview" formControlName="typeofWaiverLid"
                                  (change)="changefunction()">

                                </ng-select>



                              </div>
                            </div>
                            <div class="row mt-1">
                              <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ClientDataForm">
                                <label class=" me-1 label-bold  w-75">Client Insurance ID</label>
                                <input type="text" class="form-control w-100" name="insuranceNo"
                                  [(ngModel)]="ClientList.insuranceNo" formControlName="insuranceNo"
                                  (keypress)="keyPress($event)" minlength="5" maxlength="20"
                                  [disabled]="isgeneraltabfieldview" (change)="changefunction()" />
                              </div>
                              <div class="col-lg-6 col-md-6 d-inline-flex">
                                <label class="  label-bold  w-75">CFSS Model</label>

                                <ng-select class="w-100" [(ngModel)]="ClientList.cfssModel" [searchable]="true"
                                  [clearable]="true" [items]="cfssModel" [disabled]="isgeneraltabfieldview"
                                  (change)="changefunction()">
                                </ng-select>
                              </div>
                            </div>
                            <div class="row ">

                              <div class="col-lg-6 col-md-6 d-inline-flex">
                                <label class=" label-bold w-75">Pay Source</label>

                                <ng-select class="w-100" [(ngModel)]="ClientList.paySourceLid" [searchable]="true"
                                  [clearable]="true" [items]="PaySourceitem" bindLabel="lovName" bindValue="id"
                                  name="PaySourceName" [disabled]="isgeneraltabfieldview" (change)="changefunction()">

                                </ng-select>
                              </div>

                              <!-- Client Type General -->
                               
                                <div class="col-lg-6 col-md-6 d-inline-flex mt-1" [formGroup]="ClientDataForm">
                                  <label class=" label-bold w-75">Client Type</label>
    
                                  <ng-select class="w-100"
             [(ngModel)]="ClientList.clientTypeLid"  
             [searchable]="true"
             [clearable]="true"
             [items]="TypeofClient"
             bindLabel="lovName"  
             bindValue="id"  
             id="ClientEditclientTypeLid2"
             [disabled]="isgeneraltabfieldview"
             formControlName="clientTypeLid"
             (change)="changefunction()">
  </ng-select>


                                <!-- <app-dropdown *ngIf="!isFieldEnabled"
                                  (EmitRefreshClick)="refreshToGetDropDownValues('CLIENTTYPE')"></app-dropdown> -->
                              </div>
                            </div>
                            <div class="row ">
                              <div class="col-lg-6 col-md-6 d-inline-flex">
                                <div class="me-1 w-75">
                                  <label class=" label-bold ">Referral Date</label>                             
                                </div>
                                <div class="w-100">
                                  <input type="datetime-local" class="form-control " #editstarttime  [disabled]="isgeneraltabfieldview"
                                  [(ngModel)]="ClientList.referralDate" [max]="currentDateTime" min="1000-01-01T00:00" (change)="changefunction()" />
                                </div>
                              </div>                                   
                              </div>
                            </div>
                        </div>
                      </div>

                      <!------------------------- Contact Info ------------------->
                      <div class="card-header transparent text-muted ms-2  me-3">
                        <div class="row">
                          <div class="col-lg-6">
                            <h5 class="mb-0 font-header">Contact Info</h5>
                          </div>
                        </div>
                      </div>
                      <div class="card-body widget-body pt-2 ms-2  me-3">
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="row mt-1">
                              <!-- <div class="col-lg-6 col-md-6 d-inline-flex">
                                <label class="me-1 label-bold w-75">PMI
                                </label>
                                <input type="text" class="form-control w-100" [disabled]="isgeneraltabfieldview" name="pmi"
                                  [(ngModel)]="ClientList.pmi" (change)="changefunction()" />
                              </div> -->
                              <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ClientDataForm">
                                <label class=" me-1 label-bold  w-75">Email
                                  <!-- <sup class="super-script">*</sup> -->
                                </label>
                                <input type="text" class="form-control w-100" name="email" email="true"
                                  formControlName="ClientEmail" [(ngModel)]="ClientList.email"
                                  (change)="changefunction()" />

                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-12 mt-2 col-xs-12 d-inline-flex">
                                <label class="mr-1 label-client col-lg-5" >Event Reminder
                                </label>
                                <input type="checkbox" [(ngModel)]="ClientList.eventConfirmation" id="ClientEditmakecall"
                                [disabled]="isgeneraltabfieldview"
                                  [ngModelOptions]="{standalone: true}">
                              </div>
                              

                            </div>
                            <div class="row mt-1">
              
                              <div class="col-lg-6" style="text-align: center;">
                                <span
                                  *ngIf="ClientDataForm.controls['ClientEmail'].touched && ClientDataForm.controls['ClientEmail'].invalid">
                                  <p class="text-danger">*Enter Valid Mail</p>
                                </span>
                              </div>
                            </div>

                            <div class="row mt-1" [formGroup]="ClientDataForm">
                              <div class="col-lg-6 col-md-6 d-inline-flex" [formGroup]="ClientDataForm">
                                <label class=" me-1 label-bold  w-75">Phone 1</label>
                                <input type="text" class="form-control w-100" name="phone12" maxlength="14"
                                  minlength="14" formControlName="ClientPhone1" [(ngModel)]="ClientList.phone1"
                                  (ngModelChange)="DemographicPhoneFormat()" (keypress)="keyPress($event)"
                                  (change)="changefunction()" />
                              </div>
                              
                              <!-- <span class="error" *ngIf="Email.touched && Email.invalid">required </span> -->
                              <div class="col-lg-6 col-md-6 d-inline-flex">
                                <label class=" me-1 label-bold  w-75">Phone 2</label>
                                <input type="text" class="form-control w-100" name="phone22"
                                  formControlName="ClientPhone2" maxlength="14" minlength="14"
                                  [(ngModel)]="ClientList.phone2" (ngModelChange)="DemographicPhoneFormat()"
                                  (keypress)="keyPress($event)" (change)="changefunction()" />
                              </div>
                             
                            </div>
                          </div>

                        </div>
                        <div class="row mt-1">
                          <div class="col-lg-6 col-md-6 col-sm-12 mt-2 col-xs-12 d-inline-flex">
                            <label class="mr-1 label-client col-lg-5" >Manual Address
                            </label>
                            <input type="checkbox" [(ngModel)]="ClientList.isHomelessClient" id="ClientEditisHomelessClient"
                            [disabled]="isgeneraltabfieldview"
                              [ngModelOptions]="{standalone: true}">
                          </div>
                          
                          <div class="col-lg-6 col-md-6 d-inline-flex ">
                            <div class="w-75 d-flex justify-content-between align-items-center">

                              <label class="me-1 label-bold w-75">Street <sup class="super-script">*</sup></label>
                              <button type="button " [disabled]="isgeneraltabfieldview" class="btn blue-btn btn-sm ml-2 mb-2" id="ClientEditAddressGoogleMap"
                              data-bs-target="#SearchAddress" data-bs-toggle="modal" (click)="AddressGoogleMap = true"> Address
                            </button>
                            </div>
                            <input type="text" class="form-control w-100 ms-1" name="street"
                                [disabled]="isgeneraltabfieldview || !ClientList.isHomelessClient"
                                [(ngModel)]="ClientList.street"  [ngModelOptions]="{standalone: true}"
                                (change)="changefunction()"id="ClientEditstreet2">
                        </div>
                                          

                        </div>
                        <div class="row mt-1">

                          <div class="col-lg-6 col-md-6 d-inline-flex">
                            <label class=" me-1 label-bold  w-75">Apt</label>
                            <input type="text" class="form-control w-100" name="apt" [disabled]="isgeneraltabfieldview"
                              [(ngModel)]="ClientList.apt" (change)="changefunction()" />
                          </div>

                          <div class="col-lg-6 col-md-6 d-inline-flex">
                            <label class=" me-1 label-bold  w-75">City <sup class="super-script">*</sup></label>
                            <input type="text" id="city" class="form-control w-100" id="ClientEditcity2"
                                name="city" [disabled]="isgeneraltabfieldview || !ClientList.isHomelessClient"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="ClientList.city"
                                (change)="changefunction()" />
                        </div>                      
                        </div>
                        <div class="row mt-1">
                         
                          <div class="col-lg-6 col-md-6 d-inline-flex">
                            <label class="  label-bold  w-75">State<sup class="super-script">*</sup></label>
                            <ng-select [items]="stateList" id="state" class="w-100 "
                                [searchable]="true" [disabled]="isgeneraltabfieldview"
                                [(ngModel)]="ClientList.state" [clearable]="true"
                                bindLabel="name" bindValue="abbreviation" id="ClientEditstatelid"
                                (change)="changefunction()">
                            </ng-select>
                        </div>
                          <div class="col-lg-6 col-md-6 d-inline-flex">
                            <label class="label-bold  w-75">ZIP Code<sup class="super-script">*</sup></label>
                            <div class="d-inline-flex w-100">

                              <input type="text" class="form-control  me-1 w-100" name="zipCode" id="ClientEditzipCode"
                              [disabled]="isgeneraltabfieldview || !ClientList.isHomelessClient"  [ngModelOptions]="{standalone: true}" [(ngModel)]="ClientList.zipCode"
                                (keypress)="keyPress($event)" minlength="5" maxlength="10" (change)="changefunction()" />
                                <button type="button " class="btn blue-btn btn-sm " (click)="getzipcodeClient()" id="ClientEditgetzipcodeClient"
                                        [disabled]="ClientList.state ==null || ClientList.state =='' || ClientList.state ==undefined || ClientList.city ==null || ClientList.city =='' || isgeneraltabfieldview ||
                                                        ClientList.city ==undefined">GetZip</button>
                            </div>

                          </div>
                                   
                        </div>
                        <div class="row mt-1">
                          <div class="col-lg-6 col-md-6 d-inline-flex">
                            <label class=" me-1 label-bold  w-75">County<sup class="super-script">*</sup></label>
                            <input type="text" class="form-control w-100" name="county" id="ClientEditcounty"
                            [disabled]="isgeneraltabfieldview || !ClientList.isHomelessClient"  [ngModelOptions]="{standalone: true}"
                              [(ngModel)]="ClientList.county" (change)="changefunction()">
                          </div>
                        </div>
                        
                        
                      </div>

                      <!-- -------------------------------BILL TO && CREATE PORTAL ----------------------------------- -->
                      <div class="row">
                        <div class="col ms-2">
                          <button type="button " [disabled]="isFieldEnabled" class="btn blue-btn btn-sm ml-2"
                            (click)="clientEvv = !clientEvv;ClearingNotes();">Client
                            Portal</button>



                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-12" [hidden]="!clientEvv">
                          <div *ngIf="clientEvv">
                            <div class="card-body widget-body pt-1">
                              <div class="row align-item-center pt-1">
                                <div style="display: contents;">
                                  <h5 class="mb-0 font-header pt-2">Client Portal</h5>
                                </div>
                                <div class="col-lg-1 ">
                                  <label class="toggle-control">
                                    <input type="checkbox" [(ngModel)]="ClientList.requiredEVV"
                                      (change)="switchchange()"
                                      [disabled]="isFieldEnabled || checkClientStatus || global.clientId==0"
                                      [ngModelOptions]="{standalone: true}">
                                    <span class="control"></span>
                                  </label>
                                </div>
                                <div class="col-lg-4 col-md-6 d-inline-flex pt-1">
                                  <label class="me-1 label-bold w-150">User Name
                                    <!-- <sup class="super-script"
                                                                        *ngIf="ClientList.requiredEVV">&nbsp;*</sup> -->
                                  </label>
                                  <input type="text" class="form-control w-50" name="userName"
                                    [(ngModel)]="ClientList.userName" [ngModelOptions]="{standalone: true}" disabled />
                                </div>
                                <div class="col-lg-4 col-md-6 d-inline-flex pt-1">
                                  <label class="me-1 label-bold w-150">Password
                                    <!-- <sup class="super-script"
                                                                        *ngIf="ClientList.requiredEVV">&nbsp;*</sup> -->
                                  </label>
                                  <input type="text" class="form-control w-50" name="userName"
                                    [(ngModel)]="ClientList.password" [ngModelOptions]="{standalone: true}" disabled />
                                </div>
                                <div class="col-lg-2 col-md-6 d-inline-flex pt-1">
                                  <button class="btn btn-sm" data-bs-toggle="modal"
                                    data-bs-target="#ChangePasswordModal"
                                    [disabled]="this.ClientList.password==null || this.ClientList.password ==undefined || this.ClientList.password==''">Change
                                    Password</button>
                                </div>


                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="row">
                                            <div class="col-lg-6" [hidden]="!billto">
                                                <div *ngIf="billto">
                                                    <div class="card-header transparent text-muted">
                                                        <div class="row">
                                                            <div class="col-lg-6">
                                                                <h5 class="mb-0 font-header ms-2">Bill To</h5>
                                                            </div>
                                                            <div class="col-lg-6">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-body widget-body pt-2 ms-2 mt-1">
                                                        <div class="row">
                                                            <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                                <label class=" me-1 label-bold w-50">BillTo Name</label>
                                                                <input type="text" class="form-control w-100"
                                                                    name="billname"
                                                                    [(ngModel)]="ClientList.billto_Name" />
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                                <label class="label-bold  w-50">Street</label>
                                                                <input type="text" class="form-control w-100 "
                                                                    name="street"
                                                                    [(ngModel)]="ClientList.billto_Street" />
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-6 col-md-6 d-inline-flex">
                                                                <label class=" me-1 label-bold  w-50">City</label>
                                                                <input type="text" class="form-control w-100"
                                                                    name="city" [(ngModel)]="ClientList.billto_City" />
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 d-inline-flex">
                                                                <label class=" me-1 label-bold w-50">State</label>
                                                                <ng-select type="text" class=" w-100"
                                                                    [items]="stateList" id="state" [searchable]="true"
                                                                    [clearable]="true" bindLabel="name"
                                                                    bindValue="abbreviation"
                                                                    [(ngModel)]="ClientList.billto_State">
                                                                </ng-select>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                                <label class=" me-1 label-bold  w-50">ZIP Code</label>
                                                                <input type="text" class="form-control w-100" name="zip"
                                                                    (keypress)="keyPress($event)" minlength="5"
                                                                    maxlength="10"
                                                                    [(ngModel)]="ClientList.billto_Zipcode" />
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 d-inline-flex">

                                                                <label class=" me-1 label-bold w-50">Phone</label>
                                                                <input type="text" class="form-control w-100"
                                                                    name="phone" maxlength="14" minlength="14"
                                                                    [(ngModel)]="ClientList.billto_Phone"
                                                                    (ngModelChange)="DemographicPhoneFormat()"
                                                                    (keypress)="keyPress($event)" />
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                                <label class=" me-1 label-bold w-50">Email</label>
                                                                <input type="text" class="form-control w-100"
                                                                    name="email" email="true"
                                                                    [(ngModel)]="ClientList.Email" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-12" [hidden]="!clientEvv">
                                                <div *ngIf="clientEvv">
                                                    <div class="card-body widget-body pt-1">
                                                        <div class="row align-item-center pt-1">
                                                            <div style="display: contents;">
                                                                <h5 class="mb-0 font-header pt-2">Enable Client EVV &
                                                                    Portal
                                                                </h5>
                                                            </div>
                                                            <div class="col-lg-1 ">
                                                                <label class="toggle-control">
                                                                    <input type="checkbox"
                                                                        [(ngModel)]="ClientList.requiredEVV"
                                                                        (change)="switchchange()"
                                                                        [disabled]="isFieldEnabled || checkClientStatus || global.clientId==0"
                                                                        [ngModelOptions]="{standalone: true}">
                                                                    <span class="control"></span>
                                                                </label>
                                                            </div>
                                                            <div class="col-lg-4 col-md-6 d-inline-flex pt-1">
                                                                <label class="mr-1 label-bold w-150">User Name
                                                                    <sup class="super-script"
                                                                        *ngIf="ClientList.requiredEVV">&nbsp;*</sup>
                                                                </label>
                                                                <input type="text" class="form-control w-50"
                                                                    name="userName" [(ngModel)]="ClientList.userName"
                                                                    [ngModelOptions]="{standalone: true}" disabled />
                                                            </div>


                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->



                    </div>
                  </div>
                </div>



                <!--................................... ........................relationtaxpercent............................................ -->


                <!-- <div *ngIf="ActiveTab=='nav-notes'">
                                <div class="tab-pane fade" id="nav-notes" role="tabpanel" aria-labelledby="nav-notes"
                                    [ngClass]="{'active':ActiveTab=='nav-notes','show':ActiveTab=='nav-notes'}">

                </div>

                            </div> -->


                <div *ngIf="ActiveTab=='nav-consultation'">
                  <div id="nav-consultation" role="tabpanel" aria-labelledby="nav-consultation"
                    [ngClass]="{'active':ActiveTab=='nav-consultation','show':ActiveTab=='nav-consultation'}">

                  </div>

                </div>
                <div *ngIf="ActiveTab=='nav-relationshiptaxpercent'">
                  <div class="tab-pane fade  " id="nav-relationshiptaxpercent" role="tabpanel"
                    aria-labelledby="nav-relationshiptaxpercent"
                    [ngClass]="{'active':ActiveTab=='nav-relationshiptaxpercent','show':ActiveTab=='nav-relationshiptaxpercent'}">
                    <div class="row mb-2">
                      <div class="col ps-0">


                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                          <div class="row">
                            <div class="col-lg-6">

                              <button type="button" class="btn blue-btn btn-sm text_left mr-2" data-bs-toggle="modal"
                                data-bs-target="#taxpercentModal" (click)="Createupdate('new')"> Add RelationTax
                              </button>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>


                    <!--............ ....................................taxpercent grid.......................................................... -->

                    <div class="row mb-2"
                      *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
                                       global.globalAgencyId!=''  && global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
                      <div class="col pl-0">
                        <div widget class="card border-0 box-shadow">
                          <div class="card-body  widget-body pt-2">
                            <ejs-grid #grid id="grid" [dataSource]='data | async' [allowResizing]='true'
                              allowPaging='true' [allowSorting]='true' [allowPaging]='true'
                              [filterSettings]='filterOptions' (dataStateChange)='dataStateChange($event)'
                              (actionBegin)="onActionComplete($event)" 
                              [showColumnChooser]="true">
                              <e-columns>
                                <e-column width=150 uid="action" headerText="Actions" [showInColumnChooser]='false'>
                                  <ng-template #template let-data>
                                    <button class="btn btn-edit-table" data-bs-toggle="modal"
                                      data-bs-target="#taxpercentModal" (click)="Createupdate('edit');edit(data)"><i
                                        class="fa fa-edit"></i></button>&nbsp;

                                    <button class="btn btn-delete-table" data-bs-toggle="modal"
                                      data-bs-target="#deleteTaxPercentmodal" (click)="setDeleteId(data.id)"><i
                                        class="fa fa-trash"></i></button>
                                  </ng-template>
                                </e-column>
                                <e-column minWidth=150 field="cliEmpName" headerText="RelationShip" type='string'>
                                  <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value">
                                    </ejs-maskedtextbox>
                                  </ng-template>
                                </e-column>
                                <e-column minWidth=150 field="employerEmployeeRelationshipName"
                                  headerText="RelationShip Name" type='string'>
                                  <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value">
                                    </ejs-maskedtextbox>
                                  </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="employerEmployeeRelationshipTaxName" headerText="Tax Name"
                                  type='string'>
                                  <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value">
                                    </ejs-maskedtextbox>
                                  </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="percent" headerText="Percent" type='string'>
                                  <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value">
                                    </ejs-maskedtextbox>
                                  </ng-template>
                                </e-column>
                                <e-column minWidth=130 field="effectiveDate" headerText="Effective Date" type="date"
                                  [format]="formatOptions">
                                  <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value">
                                    </ejs-maskedtextbox>
                                  </ng-template>
                                </e-column>


                              </e-columns>
                            </ejs-grid>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <!-- ..........................................relationtaxpercent modal.................................................... -->
                <span id="opentaxpercentModal" data-bs-toggle="modal" data-bs-target="#taxpercentModal"></span>
                <div class="modal fade modalbackgrod" id="taxpercentModal" data-bs-backdrop="false">
                  <div class="modal-dialog modal-md" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title font-header" *ngIf="ModelType =='new'">Create
                          Relationship Taxpercent </h5>
                        <h5 class="modal-title font-header" *ngIf="ModelType =='edit'">Update
                          RelationShipTaxpercent
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true"></span>
                        </button>
                      </div>
                      <div class="modal-body">



                        <div class="row">
                          <div class="col-lg-6">

                            <label>RelationShip<sup class="super-script">*</sup>
                            </label>
                          </div>
                          <div class="col-lg-7">
                            <ng-select class="w-100" #select (close)="select.blur()" [(ngModel)]="RelationshipId"
                              (ngModelChange)="GetRelationshipdropdown(RelationshipId)"
                              [items]="clientemployeenamedropdown" bindLabel="Value" bindValue="Key" [searchable]="true"
                              [clearable]="true">

                            </ng-select>
                          </div>

                        </div>


                        <div class="row">
                          <div class="col-lg-6">

                            <label>RelationShip Name<sup class="super-script">*</sup>
                            </label>
                          </div>
                          <div class="col-lg-7">
                            <ng-select class="w-100"
                              [(ngModel)]="employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId"
                              [items]="relationdropdown" bindLabel="Value" bindValue="Key" [searchable]="true"
                              [clearable]="true"
                              (ngModelChange)="GetRelationshipTaxdropdown(employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId)"
                              disabled>

                            </ng-select>
                          </div>

                        </div>


                        <div class="row">
                          <div class="col-lg-6">

                            <label>Tax<sup class="super-script">*</sup>
                            </label>
                          </div>
                          <div class="col-lg-7">
                            <ng-select class="w-100"
                              [(ngModel)]="employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipTaxId"
                              [items]="relationtaxdropdown" bindLabel="Value" bindValue="Key" [searchable]="true"
                              [clearable]="true"
                              [disabled]="RelationshipId==''||RelationshipId==undefined||RelationshipId==null">
                            </ng-select>
                          </div>

                        </div>


                        <div class="row">
                          <div class="col-lg-6">
                            <label>Percent<sup class="super-script">*</sup>
                            </label>
                          </div>
                          <div class="col-lg-7">
                            <input type="number" class="form-control"
                              [(ngModel)]="employeremployeerelationshipTaxPercentBO.percent"
                              [disabled]="RelationshipId==''||RelationshipId==undefined||RelationshipId==null" />

                          </div>
                        </div>


                        <div class="row">
                          <div class="col-lg-6">
                            <label>Effective Date<sup class="super-script">*</sup>
                            </label>

                          </div>
                          <div class="col-lg-7">
                            <my-date-picker [options]="myDatePickerOptions"
                              [selDate]="employeremployeerelationshipTaxPercentBO.effectiveDate"
                              placeholder="mm/dd/yyyy"
                              (inputFieldChanged)="DateFormat($event,'inputchanged','EffectiveDate')"
                              (dateChanged)="DateFormat($event,'datechanged','EffectiveDate')"
                              [disabled]="RelationshipId==''||RelationshipId==undefined||RelationshipId==null">
                            </my-date-picker>
                          </div>
                        </div>



                      </div>

                      <div class="modal-footer">
                        <button class="btn blue-btn btn-sm" *ngIf="ModelType =='new'"
                          (click)="SaveOrUpdateActivity('new')" [disabled]="(RelationshipId==''||RelationshipId==undefined||employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId==''
            ||employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId==undefined||
            employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipTaxId==''||
            employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipTaxId==undefined||
            employeremployeerelationshipTaxPercentBO.percent==0||
            employeremployeerelationshipTaxPercentBO.percent==undefined||
            employeremployeerelationshipTaxPercentBO.effectiveDate==''||employeremployeerelationshipTaxPercentBO.effectiveDate==undefined
             )"> Save & Close </button>

                        <button class="btn blue-btn btn-sm" *ngIf="ModelType =='edit'"
                          (click)="SaveOrUpdateActivity('edit')" [disabled]="(RelationshipId==''||RelationshipId==undefined||
            employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId==undefined||
            employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipTaxId==''||
            employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipTaxId==undefined||
            employeremployeerelationshipTaxPercentBO.percent==0||
            employeremployeerelationshipTaxPercentBO.percent==undefined||
            employeremployeerelationshipTaxPercentBO.effectiveDate==''||
            employeremployeerelationshipTaxPercentBO.effectiveDate==undefined
             )"> Update & Close </button>
                        <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>

                      </div>

                    </div>
                  </div>
                </div>



                <span id="closeTaxPercentModal" data-bs-target="#deleteTaxPercentmodal" data-bs-toggle="modal"></span>
                <div class="modal fade" id="deleteTaxPercentmodal" data-bs-backdrop="false">
                  <div class="modal-dialog modal-md" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title font-header">Delete Record</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true"> </span>
                        </button>

                      </div>
                      <div class="modal-body">
                        <div class="row">
                          <div class="col-lg-12">
                            <label>Do you want to delete this record ?</label>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn blue-btn btn-sm" (click)="DeleteTaxPercent()">Yes</button>
                        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!------------------------------------------ relationship Tap ------------------------------------------->
            <div *ngIf="ActiveTab=='nav-relationship'">
              <div class="tab-pane fade" id="nav-relationship" role="tabpanel" aria-labelledby="nav-relationship"
                [ngClass]="{'active':ActiveTab=='nav-relationship','show':ActiveTab=='nav-relationship'}">

              </div>
            </div>


            <!------------------------------------ authorization Tap------------------------------------------------------>
            <div *ngIf="ActiveTab=='nav-authorization'">
              <div class="tab-pane fade" id="nav-authorization" role="tabpanel" aria-labelledby="nav-authorization"
                [ngClass]="{'active':ActiveTab=='nav-authorization','show':ActiveTab=='nav-authorization'}">
                <div class="row mt-3 mr-0 ">
                  <div class="col-lg-12 ml-3 text-right">

                  </div>
                </div>
              </div>
            </div>

            <!-----------------------------start of care-------------------------------------------------->
            <div *ngIf="ActiveTab=='nav-soc'">
              <div class="tab-pane fade" id="nav-soc" role="tabpanel" aria-labelledby="nav-soc"
                [ngClass]="{'active':ActiveTab=='nav-soc','show':ActiveTab=='nav-soc'}">
                <div class="row mt-3 mr-0 ">
                  <div class="col-lg-12 ml-3 text-right">
                    <app-startofcarelist *ngIf="!EditSOC && ActiveTab== 'nav-soc'"
                      (EventToEditSOC)="dataEmitfromChildSOC($event)">
                    </app-startofcarelist>
                  </div>
                </div>
              </div>
            </div>



            <!----------------------- certificaion tab ---------------------------------->

            <div *ngIf="ActiveTab=='nav-certification'">
              <div class="tab-pane fade" id="nav-certification" role="tabpanel" aria-labelledby="nav-certification"
                [ngClass]="{'active':ActiveTab=='nav-certification','show':ActiveTab=='nav-certification'}">
                <div class="row mt-3 mr-0 ">
                  <div class="col-lg-12 ml-3 text-right">
                    <app-client-certificate-list *ngIf="!Editcert && ActiveTab== 'nav-certification' "
                      (DatafromCertificate)="dataEmitFromCertificate($event)">

                    </app-client-certificate-list>
                  </div>
                </div>
              </div>
            </div>





            <!-----------------------------Contact-------------------------------------------------->

            <div *ngIf="ActiveTab=='nav-contacts'">
              <div class="tab-pane fade" id="nav-contacts" role="tabpanel" aria-labelledby="nav-contacts"
                [ngClass]="{'active':ActiveTab=='nav-contacts','show':ActiveTab=='nav-contacts'}">

                <div class="row ml-3 mt-3">
                  <div class="row ms-3 mt-3">
                    <div class="col-lg-1">
                      Filter
                    </div>
                    <div class="col-lg-2">
                      <input type="radio" [disabled]="this.global.viewTabs" name="contacts" id="contacts"
                        value="contacts" [(ngModel)]="contactfilter" (change)="callingfunction()">&nbsp; Contacts
                    </div>
                    <div class="col-lg-2">
                      <input type="radio" [disabled]="this.global.viewTabs" name="case" id="case" value="case"
                        [(ngModel)]="contactfilter" (change)="callingfunction()"> &nbsp; CaseManagers
                    </div>
                    <div class="col-lg-2">
                      <input type="radio" name="care" [disabled]="this.global.viewTabs" value="care" id="care"
                        [(ngModel)]="contactfilter" (change)="callingfunction()"> &nbsp; CareCoordinators
                    </div>
                    <div class="col-lg-2">
                      <input type="radio" name="fms" [disabled]="this.global.viewTabs" value="fms" id="fms"
                        [(ngModel)]="contactfilter" (change)="callingfunction()"> &nbsp; FMS Agency
                    </div>
                     <div class="col-lg-2">
                      <input type="radio" name="hha" [disabled]="this.global.viewTabs" value="hha" id="hha"
                        [(ngModel)]="contactfilter" (change)="callingfunction()"> &nbsp; Home Health Agency
                    </div>

                  </div>


                </div>

                <div *ngIf="contactfilter == 'contacts'">
                  <div class="row  mr-0">
                    <div class="col-lg-12 text-right ">
                      <button class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#modalSaveOrUpdate"
                        [disabled]="this.global.viewTabs"  *ngIf="fp?.contactcreate">Add
                        Contact</button>
                    </div>
                  </div>
                </div>

                <div *ngIf="contactfilter == 'case'">
                  <div class="card-body widget-body pb-0 pt-2 mb-4">
                    <div class="row mt-2 mb-2">
                      <div class="col-lg-1 ms-2">
                        <label>Status</label>
                      </div>
                      <div class="col-lg-2">
                        <!-- <select class="form-select" [(ngModel)]="CaseStatus" (ngModelChange)="getclientCaseLst()" id="getclientCaseLst">
                                          <option  name="lovName" [items]="StatusFilterLst"></option>
                                        </select> -->
                        <ng-select [clearable]="true" [searchable]="true" [items]="StatusLst" bindLabel="lovName"
                          bindValue="id" [(ngModel)]="CaseStatus" id="getclientCaseLst"
                          (ngModelChange)="getclientCaseLst()">
                        </ng-select>
                      </div>

                      <div class="col-lg-4 ">
                        <button class="btn btn-primary btn-sm"
                          (click)="caseenable=false; casetype='edit'; assignCaseManager=null; AssignCaseManagerBoolean=true; getCaseManagerDropdown(); getStatusforCase();"
                          data-bs-toggle="modal" data-bs-target="#casemanager" id="assigncasemanager">
                          Assign Case Manager
                        </button>
                        <button class="btn btn-primary btn-sm ms-3 mt-1"
                          (click)="caseenable=true; casetype='view'; AssignCaseManagerBoolean=false"
                          data-bs-toggle="modal" data-bs-target="#casemanager" id="addcasemanager">
                          Add Case Manager
                        </button>
                      </div>
                    </div>

                    <div class="row">
                      <ejs-grid #gridcasemanager [dataSource]='datacase | async' [allowResizing]='true'
                        *ngIf="global.globalAgencyId!=0" [allowPaging]='true' [pageSettings]='initialPage'
                        (resizeStop)="onResizeCase($event)" (dataStateChange)='dataStateChangeCasemanager($event)'
                        (actionBegin)="onActionCompleteCasemanager($event)">

                        <e-columns>
                          <e-column minWidth="200" headerText="Actions" uid="action" textAlign="center"
                            [showInColumnChooser]='false'>
                            <ng-template #template let-data>
                              <button class="btn btn-edit-table me-1" (click)="editcasemanager(data)"
                                id="editcasemanager" data-bs-toggle="modal" data-bs-target="#casemanager">
                                <i class="fa fa-edit"></i>
                              </button>
                              <button class="btn btn-delete-table" (click)="deletecaseId=data.id" id="deletecasemanager"
                                data-bs-toggle="modal" data-bs-target="#deletecase">
                                <i class="fa fa-trash"></i>
                              </button>
                            </ng-template>
                          </e-column>

                          <e-column minWidth="100" field="caseManagerName" headerText="Name"></e-column>
                          <e-column minWidth="100" field="county" headerText="County"></e-column>
                          <e-column minWidth="100" field="state" headerText="State"></e-column>
                          <e-column minWidth="100" field="city" headerText="City"></e-column>
                          <e-column minWidth="100" field="zip" headerText="Zip"></e-column>
                          <e-column minWidth="100" field="phone" headerText="Telephone"></e-column>
                          <e-column minWidth="100" field="fax" headerText="Fax"></e-column>
                          <e-column minWidth="100" field="alternateFax" headerText="Alternative Fax"></e-column>
                          <e-column minWidth="100" field="email" headerText="Email"></e-column>
                          <e-column minWidth="100" field="statusName" headerText="Status"></e-column>

                          <e-column field="activeDate" headerText="Active Date" minWidth="100" type="datetime"
                            [allowFiltering]="false" [format]='formatOptions'>
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>

                          <e-column field="inActiveDate" headerText="InActive Date" minWidth="100" type="datetime"
                            [allowFiltering]="false" [format]='formatOptions'>
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                        </e-columns>
                      </ejs-grid>

                      <div class="col-lg-12">
                        <div *ngIf="caseLst.length == 0" class="text-center text-danger">
                          <p>No data available</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Care Cordinator -->
                <div *ngIf="contactfilter == 'care'">
                  <div class="card-body  widget-body pb-0 pt-2 mb-4">
                    <div class="row mt-2 mb-2">
                      <div class="col-lg-1 ms-2">
                        <label>Status</label>
                      </div>
                      <div class="col-lg-2">
                        <!-- <select class="form-select" [(ngModel)]="CaseStatus" (ngModelChange)="getclientCaseLst()" id="getclientCaseLst">
                                        <option  name="lovName" [items]="StatusFilterLst"></option>
                                      </select> -->
                        <ng-select [clearable]="true" [searchable]="true" [items]="StatusLst" bindLabel="lovName"
                          bindValue="id" [(ngModel)]="CareStatus" (ngModelChange)="getclientCareLst()"
                          id="getclientCareLst">
                        </ng-select>
                      </div>

                      <div class="col-lg-2">
                        <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#carecoordinator"
                          id="assigncarecoordinator"
                          (click)="careenable=false;caretype='edit';assignCareCoordinator=null;AssignCareCoordinatorBoolean=true;getCareCoordinatordropdown();getStatusforCase()">Assign
                          Care
                          Coordinator</button>
                      </div>
                      <div class="col-lg-2">
                        <button class="btn btn-primary btn-sm ml-3 " data-bs-toggle="modal"
                          data-bs-target="#carecoordinator" id="addcarecoordinator"
                          (click)="careenable=true;caretype='view';AssignCareCoordinatorBoolean=false">Add
                          Care Coordinator</button>
                      </div>

                    </div>
                    <div class="row">
                      <ejs-grid #gridcarecoordinator [dataSource]='datacare | async' [allowResizing]='true'
                        allowPaging='true' [pageSettings]='initialPage' (resizeStop)="onResize($event)"
                        (dataStateChange)='dataStateChangeCare($event)' (actionBegin)="onActionCompleteCare($event)">
                        <e-columns>
                          <e-column minWidth=100 headerText="Actions" uid="action" textAlign="center"
                            [showInColumnChooser]='false'>
                            <ng-template #template let-data>
                              <div class="col-lg-2">
                                <button class="btn btn-edit-table mr-1" data-bs-toggle="modal"
                                  (click)="editcaremanager(data)" id="editcarecoordinator"
                                  data-bs-target="#carecoordinator"><i class="fa fa-edit"></i></button>&nbsp;
                                <button class="btn btn-delete-table" data-bs-toggle="modal"
                                  (click)="deletecareId=data.id" id="deletecarecoordinator"
                                  data-bs-target="#deletecare"><i class="fa fa-trash"></i></button>
                              </div>
                            </ng-template>

                          </e-column>
                          <e-column minWidth=100 field="careCoordinatorName" headerText="Name"></e-column>
                          <e-column minWidth=100 field="county" headerText="County"></e-column>
                          <e-column minWidth=100 field="phoneNumber" headerText="phoneNumber"></e-column>
                          <e-column minWidth=100 field="fax" headerText="Fax"></e-column>
                          <e-column minWidth=100 field="alternateFax" headerText="Alternative Fax"></e-column>
                          <e-column minWidth=100 field="email" headerText="Email"></e-column>
                          <e-column minWidth=100 field="statusName" headerText="Status"></e-column>

                          <e-column field="activeDate" headerText="Active Date" minWidth=100 type="datetime"
                            [allowFiltering]="false" [format]='formatOptions'>
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                          <e-column field="inActiveDate" headerText="InActive Date" minWidth=100 type="datetime"
                            [allowFiltering]="false" [format]='formatOptions'>
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>

                        </e-columns>
                      </ejs-grid>
                      <div class="col-lg-12">
                        <div *ngIf="carecoLst.length == 0" class="text-center" style="color:red">
                          <p>No data available</p>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
<!-- fms -->
                <div *ngIf="contactfilter == 'fms'">
                  <div class="card-body  widget-body pb-0 pt-2 mb-4">
                    <div class="row mt-2 mb-2">
                      <div class="col-lg-1 ms-2">
                        <label>Status</label>
                      </div>
                      <div class="col-lg-2">
                        <!-- <select class="form-select" [(ngModel)]="CaseStatus" (ngModelChange)="getclientCaseLst()" id="getclientCaseLst">
                                        <option  name="lovName" [items]="StatusFilterLst"></option>
                                      </select> -->
                        <ng-select [clearable]="true" [searchable]="true" [items]="StatusLst" bindLabel="lovName"
                          bindValue="id" [(ngModel)]="fmsStatus" (ngModelChange)="getclientfmsLst()"
                          id="getclientfmsLst">
                        </ng-select>
                      </div>

                      <div class="col-lg-2">
                        <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#fmsagency"
                          id="assignfms"
                          (click)="fmsagencyenable=false;fmstype='edit';assignfmsagency=null;AssignfmsagencyBoolean=true;getFMSAgencydropdown();getStatusforCase()">Assign
                          FMS
                          Agency</button>
                      </div>
                      <div class="col-lg-2">
                        <button class="btn btn-primary btn-sm ml-3 " data-bs-toggle="modal" data-bs-target="#fmsagency"
                          id="assignfmsagency" (click)="fmsagencyenable=true;fmstype='view';AssignfmsagencyBoolean=false">Add
                          FMS Agency</button>
                      </div>

                    </div>
                    <div class="row">
                      <ejs-grid #gridfmsagency [dataSource]='datafms | async' [filterSettings]='filterOptions' [allowResizing]='true'
                        allowPaging='true' [pageSettings]='initialPage' (dataStateChange)='dataChangeFms($event)' 
                        (actionBegin)="onActionFms($event) ">
                        <e-columns>
                          <e-column width=100 headerText="Actions" uid="action" textAlign="center"
                            >
                            <ng-template #template let-data>
                              <div class="col-lg-2">
                                <button class="btn btn-edit-table mr-1" data-bs-toggle="modal"
                                  (click)="editfmsmanager(data)" id="editfmsbtn" data-bs-target="#fmsagency"><i
                                    class="fa fa-edit"></i></button>&nbsp;
                                <button class="btn btn-delete-table" data-bs-toggle="modal"
                                  (click)="deletefmsId=data.id" id="deletefmsbtn" data-bs-target="#deletefms"><i
                                    class="fa fa-trash"></i></button>
                              </div>
                            </ng-template>

                          </e-column>
                          <e-column field="statusName" headerText="Status" width="150" type="string">
                          </e-column>
                          <e-column width=150 field="providerName" headerText="Provider Name" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>

                          <e-column width=150 field="npi" headerText="NPI" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                          <e-column width=150 field="phoneNumber" headerText="Phone Number" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                          <e-column width=150 field="address" headerText="Address" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                          <e-column width=150 field="city" headerText="City" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                          <e-column width=150 field="state" headerText="State" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                          <e-column width=150 field="zipCode" headerText="Zip Code" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                          <e-column width=150 field="contactName" headerText="Contact Name" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                          <e-column width=150 field="email" headerText="Email" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                          <e-column width=150 field="fax" headerText="Fax" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                          <e-column width=150 field="fmsFee" headerText="FMS Fee" type="Number">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                           <e-column width=150 field="activeDate" headerText="Active Date" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                           <e-column width=150 field="inActiveDate" headerText="InActive Date" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                         

                        </e-columns>
                      </ejs-grid>
                      <div class="col-lg-12">
                        <div *ngIf="fmsagencyLst?.length == 0" class="text-center" style="color:red">
                          <p>No data available</p>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div *ngIf="contactfilter == 'hha'">
                  <div class="card-body  widget-body pb-0 pt-2 mb-4">
                    <div class="row mt-2 mb-2">
                      <div class="col-lg-1 ms-2">
                        <label>Status</label>
                      </div>
                      <div class="col-lg-2">
                        <!-- <select class="form-select" [(ngModel)]="CaseStatus" (ngModelChange)="getclientCaseLst()" id="getclientCaseLst">
                                        <option  name="lovName" [items]="StatusFilterLst"></option>
                                      </select> -->
                        <ng-select [clearable]="true" [searchable]="true" [items]="StatusLst" bindLabel="lovName"
                          bindValue="id" [(ngModel)]="hhaStatus" (ngModelChange)="getclienthhaLst()"
                          id="getclienthhaLst">
                        </ng-select>
                      </div>

                      <div class="col-lg-2">
                        <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#hhaagency"
                          id="assignhha"
                          (click)="hhaagencyenable=false;hhatype='edit';assignhhaagency=null;AssignhhaagencyBoolean=true;getHHAAgencydropdown();getStatusforCase()">Assign
                          Home Health
                          Agency</button>
                      </div>
                      <div class="col-lg-2">
                        <button class="btn btn-primary btn-sm ml-3 " data-bs-toggle="modal" data-bs-target="#hhaagency"
                          id="assignhhaagency" (click)="hhaagencyenable=true;hhatype='view';AssignhhaagencyBoolean=false">Add
                          Home Health Agency</button>
                      </div>

                    </div>
                    <div class="row">
                      <ejs-grid #gridhhaagency [dataSource]='datahha | async'  [allowResizing]='true'
                        allowPaging='true' [pageSettings]='initialPage' (dataStateChange)='dataChangeHHA($event)'
                        (actionBegin)="onActionHHA($event)">
                        <e-columns>
                          <e-column width=100 headerText="Actions" uid="action" textAlign="center"
                            >
                            <ng-template #template let-data>
                              <div class="col-lg-2">
                                <button class="btn btn-edit-table mr-1" data-bs-toggle="modal"
                                  (click)="edithhamanager(data)" id="edithhabtn" data-bs-target="#hhaagency"><i
                                    class="fa fa-edit"></i></button>&nbsp;
                                <button class="btn btn-delete-table" data-bs-toggle="modal"
                                  (click)="deletehhaId=data.id" id="deletehhabtn" data-bs-target="#deletehha"><i
                                    class="fa fa-trash"></i></button>
                              </div>
                            </ng-template>

                          </e-column>
                           <e-column field="statusName" headerText="Status" width="150" type="string">
                </e-column>
                 <e-column width=150 field="hhaName" headerText="Provider Name" type="string">
                     <ng-template #filterTemplate let-data>
                         <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                     </ng-template>
                 </e-column>
 
                
              
                <e-column width=150 field="address" headerText="Address" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                   <e-column width=150 field="apt" headerText="Apt" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="city" headerText="City" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="state" headerText="State" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="zipCode" headerText="Zip Code" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                   <e-column width=150 field="phoneNumber" headerText="Phone Number" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
             
                <e-column width=150 field="email" headerText="Email" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="fax" headerText="Fax" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                           <e-column width=150 field="activeDate" headerText="Active Date" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                           <e-column width=150 field="inActiveDate" headerText="InActive Date" type="string">
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                          </e-column>
                         

                        </e-columns>
                      </ejs-grid>
                      <div class="col-lg-12">
                        <div *ngIf="fmsagencyLst?.length == 0" class="text-center" style="color:red">
                          <p>No data available</p>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>




            <!-- -----------------------------------------------DOCUMENT TAP-------------------------------------------------- -->
            <div *ngIf="ActiveTab=='nav-documents'">
              <div class="tab-pane fade" id="nav-documents" role="tabpanel" aria-labelledby="nav-documents"
                [ngClass]="{'active':ActiveTab=='nav-documents','show':ActiveTab=='nav-documents'}">


              </div>
            </div>

            <!-- -----------------------------------------------BUDGET TAP---------------------------------------------- -->
            <!-- <div *ngIf="ActiveTab=='nav-budget'">
              <div class="tab-pane fade" id="nav-budget" role="tabpanel" aria-labelledby="nav-budget"
                [ngClass]="{'active':ActiveTab=='nav-budget','show':ActiveTab=='nav-budget'}">

                <div class="row">
                  <div class="col">
                    <div class="card-body widget-body pt-2 ms-2 me-3">
                      <div class="row">
                        <div class="col-lg-12">
                          <app-budgetimport [bugetInput]="BudgetImportData"
                            (dataemitBudgetimport)="dataemitBudgetimport($event)">
                          </app-budgetimport>

                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div> -->

            <!-------------------------------------------PURCHASSE TAP------------------------------------------------------  -->
            <div *ngIf="ActiveTab=='nav-purchase'">
              <div class="tab-pane fade" id="nav-purchase" role="tabpanel" aria-labelledby="nav-purchase"
                [ngClass]="{'active':ActiveTab=='nav-purchase','show':ActiveTab=='nav-purchase'}">
              </div>
            </div>
            <!-- -----------------------------------------------Serviceplan TAP---------------------------------------------- -->
            <div *ngIf="ActiveTab=='nav-serviceplan'">
              <div class="tab-pane fade" id="nav-serviceplan" role="tabpanel" aria-labelledby="nav-serviceplan"
                [ngClass]="{'active':ActiveTab=='nav-serviceplan','show':ActiveTab=='nav-serviceplan'}">

                <div class="row">
                  <div class="col">
                    <div class="card-body widget-body pt-2 ms-2 me-3">
                      <div class="row">
                        <div class="col-lg-12">

                          <app-serviceplan [planInput]="ServicePlanImportData"
                            (dataemitplanimport)="dataemitServiceimport($event)">
                          </app-serviceplan>

                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="ActiveTab=='nav-document'">
              <div class="tab-pane fade" id="nav-document" role="tabpanel" aria-labelledby="nav-document"
                [ngClass]="{'active':ActiveTab=='nav-document','show':ActiveTab=='nav-document'}">

              </div>
            </div>
             <div *ngIf="ActiveTab=='nav-csengagement'">
              <div class="tab-pane fade" id="nav-csengagement" role="tabpanel" aria-labelledby="nav-csengagement"
                [ngClass]="{'active':ActiveTab=='nav-csengagement','show':ActiveTab=='nav-csengagement'}">
                 <div class="row">
                  <div class="col">

                <div class="row ml-3 mt-3">
                  <div class="row ms-3 mt-3">
                    <div class="col-lg-1">
                      Filter
                    </div>
                    <div class="col-lg-2">
                      <input type="radio" [disabled]="this.global.viewTabs" name="csengagement" id="csengagement"
                        value="engagement" [(ngModel)]="csfilter" >&nbsp; Engagement
                    </div>
                    <div class="col-lg-2">
                      <input type="radio" [disabled]="this.global.viewTabs" name="csinbox" id="csinbox" value="inbox"
                        [(ngModel)]="csfilter" > &nbsp; Inbox
                    </div>
                     <div class="col-lg-2">
                      <input type="radio" [disabled]="this.global.viewTabs" name="csticket" id="csticket" value="ticket"
                        [(ngModel)]="csfilter" > &nbsp; Ticket
                    </div>
                  

                  </div>


                </div>

                <div *ngIf="csfilter == 'engagement'">
                    <div class="card-body widget-body pt-2 ms-2 me-3 mt-4">
                      <div class="row">
                        <div class="col-lg-12">


                          <app-engagement [clientTab]='clienttab'></app-engagement>

                        </div>

                      </div>
                    </div>
                </div>
                <div *ngIf="csfilter == 'inbox'">
                    <div class="card-body widget-body pt-2 ms-2 me-3 mt-4">
                      <div class="row">
                        <div class="col-lg-12">


                          <app-inbox [clientTab]='clienttab'></app-inbox>

                        </div>

                      </div>
                    </div>
                </div>
                 <div *ngIf="csfilter == 'ticket'">
                    <div class="card-body widget-body pt-2 ms-2 me-3 mt-4">
                      <div class="row">
                        <div class="col-lg-12">


                          <app-ticket [clientTab]='clienttab'></app-ticket>

                        </div>

                      </div>
                    </div>
                </div>

                  </div>
                </div>
              </div>
            </div>
            
          </div>
          <app-client-employee-relationship [CERelation]="ClientEmployeeRelationship" *ngIf="isRelationShip">
          </app-client-employee-relationship>

          <app-client-employee-contact [ContactRelation]="ClientEmployeeContact"
            *ngIf="isRelationcontact && contactfilter == 'contacts'">
          </app-client-employee-contact>

          <app-consultation-services [csform]="Consultationform" *ngIf="isconsultationform">
          </app-consultation-services>

          <app-client-employee-dynamicform [DynamicFormRelation]="ClientEmployeeDynamicForm"
            *ngIf="isdynamicFormcontact">
          </app-client-employee-dynamicform>
          <app-client-authorization *ngIf="!EditAuthorization &&ActiveTab== 'nav-authorization'"
            (EventToEditAuth)="dataEmitfromChild($event)" [AuthRelation]="authTypeFilter">
          </app-client-authorization>
          <app-purchase-request *ngIf="purchaseemit" [purchaseEmit]="purchaseEmitBo"></app-purchase-request>

          <app-client-notes *ngIf="isNotes" [Client]="ClientList">
          </app-client-notes>

          <app-client-employee-document [DocumentRelation]="DocumentListType" *ngIf="DocumentListbool">
          </app-client-employee-document>

        </div>
      </div>
    </div>
  </div>
  <span>
    <app-budgetplan-form *ngIf="BudgetImportData.edit" (dataEmitFromCDCSPlan)="dataEmitFromCDCSPlan($event)"
      [budgetPlan]="BudgetImportData">
    </app-budgetplan-form>
  </span>

  <span id="PORTALMODAL" data-bs-toggle="modal" data-bs-target="#CreatePortalModal"></span>
  <div class="modal fade" id="CreatePortalModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">
            <span>Enable Client Portal</span>
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"> </span>
          </button>
        </div>
        <div class="modal-body">
          <!-- <p>Email : <strong class="pl-1"> {{ClientList.email}}</strong></p>-->
          <label>This will create & email the default username & password for this user!</label>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm"
            (click)="this.sendToPortalBO.password=null;CreatePoratl()">Create</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="ClientList.requiredEVV = false">Cancel</button>
        </div>
      </div>
    </div>
  </div>



  <span id="openSecurityModal" data-bs-target="#ViewSecurity" data-bs-toggle="modal"></span>
  <div class="modal fade" id="ViewSecurity" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">
            EIN
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          <!-- <div class="row pb-2">
                    <div class="col-lg-4 col-md-4">
                        <label class=" me-1 label-bold  w-100">Tax Id</label>
                    </div>
                    <div class="col-lg-8 col-md-8">
                        <input type="text" class="form-control w-75" name="tax" [(ngModel)]="ClientList.taxId"
                            [disabled]="global.viewTabs" />
                    </div>
                </div>
                <div class="row pb-2">
                    <div class="col-lg-4 col-md-4">
                        <label class=" me-1 label-bold  w-100">UnEmployment Number</label>
                    </div>
                    <div class="col-lg-8 col-md-8">
                        <input type="text" class="form-control w-75" name="unemp"
                            [(ngModel)]="ClientList.unemploymentNumber" [disabled]="global.viewTabs" />
                    </div>
                </div> -->
          <div class="row" style="padding-left: 20px;padding-right: 20px;">
            <!-- <div class="col-lg-4 col-md-4">
                        <label class="label-bold w-100">Does client have EIN</label>
                    </div>
                    <div class="col-lg-8 col-md-8 d-inline-flex">
                        <div *ngFor="let i of isEinList" class="d-flex">
                            <input type="radio" [value]="i.id" [(ngModel)]="ClientList.isEinLid"
                                [disabled]="global.viewTabs"
                                (ngModelChange)="EinChangesFun(ClientList.isEinLid)" />
                            <span class="pt-2">{{i.lovName}}</span> -->
            <!-- </div> -->
            <input type="text" class="form-control m-1" placeholder="EIN number" [(ngModel)]="ClientList.isEin"
              (keypress)="keyPress($event)" [disabled]="!disableEin || global.viewTabs" />
            <!-- </div> -->
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  <span id="openEvvModal" data-bs-target="#EnableEvv" data-bs-toggle="modal">
  </span>
  <div class="modal fade" id="EnableEvv" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="font-header">
            Disable Client Portal</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"
            (click)="ClientList.requiredEVV=!ClientList.requiredEVV"> </button>
        </div>
        <div class="modal-body">
          <label *ngIf="!ClientList.requiredEVV "> This will log out all the sessions for this user!</label>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm" (click)="passwordResetFunction()">Continue</button>
          <button type="button" class="btn btn-primary btn-sm" data-bs-dismiss="modal"
            (click)="ClientList.requiredEVV=!ClientList.requiredEVV">No</button>
        </div>
      </div>
    </div>
  </div>

  <app-client-authorization-edit *ngIf="EditAuthorization" (EventToEditAuth)="dataEmitfromChild($event)"
    [DataFromAuthorizationList]="EditOptions">
  </app-client-authorization-edit>


  <span id="PasswordChangeModal" data-bs-toggle="modal" data-bs-target="#ChangePasswordModal"></span>
  <div class="modal fade" id="ChangePasswordModal" data-backdrop="static">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">
            <span>Password Change</span>
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"> </span>
          </button>
        </div>
        <div class="modal-body">
          <div>
            <div class="col-lg-8 col-md-6">
              <label class="me-1 label-bold w-150">New Password
              </label>
              <input type="text" class="form-control" name="npassowrd" [(ngModel)]="NewPassword"
                [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="col-lg-8 col-md-6 pt-1">
              <label class="me-1 label-bold w-150">Conform Password
              </label>
              <input type="text" class="form-control" name="cpassword" [(ngModel)]="ConformPassword"
                [ngModelOptions]="{standalone: true}" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm"
            [disabled]="ConformPassword==null || ConformPassword ==undefined || ConformPassword =='' || NewPassword == '' || NewPassword == null || NewPassword == undefined "
            (click)="changePassword()">Submit</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <!---------------------------------------close Aleart-------------------------------------------------------------------->
  <span id="cancelmodal" data-bs-toggle="modal" data-bs-target="#CloseModal"></span>
  <div class="modal fade" id="CloseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip " role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          You want to close without save?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
            (click)="BackToClientList()">Yes</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
        </div>
      </div>
    </div>
  </div>


  <!-- showPopup -->
  <div class="modal fade " id="showPopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Client Details</h5>
          <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Name:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label>{{ClientList.lastName}}&nbsp;{{ClientList.firstName}}&nbsp;{{ClientList.middleName}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Address:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label>{{ClientList.street}}&nbsp;{{ClientList.apt}}</label><br>
              <label>{{ClientList.city}}</label><br>
              <label>{{ClientList.state}}&nbsp; {{ClientList.zipCode}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Email:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label> {{ClientList.email}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Phone:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label> {{ClientList.phone1}}</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <!--  showResponsiblePartyDetails-->
  <div class="modal fade " id="showResponsiblePartyDetails" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Participant's Representative Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Name:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label>{{this.Responsibleinfo.name}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Address:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label>{{this.Responsibleinfo.street}}</label><br>
              <label>{{this.Responsibleinfo.city}}</label><br>
              <label>{{this.Responsibleinfo.state}}&nbsp; {{this.Responsibleinfo.zipCode}}</label>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Email:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label>{{ this.Responsibleinfo.email}}</label><br>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Phone:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label>{{ this.Responsibleinfo.phoneNumber}}</label><br>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Relationship:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label> {{this.Responsibleinfo.relationship}}</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <!-- showEmergencyContactDetails -->
  <div class="modal fade " id="showEmergencyContactDetails" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Emergency Contact Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Name:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label>{{ this.EmergencyContactinfo.name}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Address:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label>{{this.EmergencyContactinfo.street}}</label><br>
              <label>{{EmergencyContactinfo.city}}</label><br>
              <label>{{EmergencyContactinfo.state}}&nbsp; {{EmergencyContactinfo.zipCode}}</label>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Email:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label>{{ this.EmergencyContactinfo.email }}</label><br>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Phone:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label>{{ this.EmergencyContactinfo.phoneNumber }}</label><br>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <label class="modal-title font-header">Relationship:<sup class="super-script"></sup>
              </label>
            </div>
            <div class="col-lg-7">
              <label> {{this.EmergencyContactinfo.relationship }}</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>


  <span id="openmonitorListModal" data-bs-target="#monitorListmodal" data-bs-toggle="modal"></span>
  <div class="modal fade" id="monitorListmodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Monitor List</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clearlist('cancel')"
            aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-5">
                  <label>Select Color Code<sup class="super-script">*</sup>
                  </label>
                </div>
                <div class="col-lg-7">
                  <!-- <select  formControlName="colorcode" [(ngModel)]="saveListFields.colorcode" class="form-select">
                                    <option value="Red"><i style="color: red;" class="fa fa-circle"></i></option>
                                    <option value="Yellow"><i style="color: yellow;" class="fa fa-circle"></i></option>
                                    <option value="Green"><i style="color: green;" class="fa fa-circle"></i></option>
                                    <option value="Blue"><i style="color: blue;" class="fa fa-circle"></i></option>
                                </select> -->

                  <!-- <select  formControlName="colorcode" [(ngModel)]="saveListFields.colorcode" class="form-select">
                                    <option value="Red" style="color: red;">Red</option>
                                    <option value="Yellow"><i style="color: yellow;" class="fa fa-circle"></i></option>
                                    <option value="Green"><i style="color: green;" class="fa fa-circle"></i></option>
                                    <option value="Blue"><i style="color: blue;" class="fa fa-circle"></i></option>
                                </select> -->

                  <ng-select [items]="monitorList" bindLabel="label" [(ngModel)]="selectedColor"
                    placeholder="Select color">
                    <ng-template ng-label-tmp let-item="item">
                      <i class="fa fa-circle" [ngStyle]="{'color': item.value}"></i> {{ item.label }}
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <i class="fa fa-circle" [ngStyle]="{'color': item.value}"></i> {{ item.label }}
                    </ng-template>
                  </ng-select>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm"
            [disabled]="selectedColor==null || selectedColor ==undefined || selectedColor==''"
            (click)="Savemonitor()">Save & Close</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
            (click)="clearlist('cancel')">Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <!-- ////////////////////////////////Create and Update Monitor List/////////////////////////////////// -->
  <span id="openemitmonitormodal" data-bs-target="#emitmonitormodal" data-bs-toggle="modal"></span>
  <div class="modal fade modalbackgrod" id="emitmonitormodal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Assign Monitor List</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body scroll">
          <app-client-monitorlist [ToMonitor]="this.EmitMonitorList"
            *ngIf="this.EmitMonitorList?.isClient && this.EmitMonitorList.clientId!=null"
            (DataFromMonitor)="DataFromClientEmployeeMonitor($event)"></app-client-monitorlist>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm ml-3" data-bs-dismiss="modal"
            data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>


  <span id="multipledeletemonitor" data-bs-toggle="modal" data-bs-target="#deletemonitor"></span>
  <div class="modal hide fade modalbackgrod" id="deletemonitor" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog ">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Monitor Warning</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"
            (click)="ClientList.isMonitor=!ClientList.isMonitor"></button>

        </div>
        <div class="modal-body ">
          Do you want to turn off the monitor?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" (click)="deleteMonitoroff()">Yes</button>

          <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal">No</button>
        </div>
      </div>
    </div>
  </div>

  <app-startofcareedit *ngIf="EditSOC" [DataFromSOC]="EditSOCOptions" (BacktoClientSOC)="EventfromSOCEdit($event)">
  </app-startofcareedit>


  <!-------------------------------Case Manger--------------------------------------------------------------->
  <span id="Caseopen" data-bs-toggle="modal" data-bs-target="#casemanager"></span>

  <div class="modal fade" id="casemanager" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" [ngClass]="{'modal-xl': caseenable, '' : !caseenable}">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel" style="font-weight: 700;">Case Manager</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="closecasemanager();caseenable=false;" id="closecasemanager"></button>
        </div>
        <div class="modal-body ml-1" [ngStyle]="caseenable == true ? {'height': '450px','overflow-y': 'auto'} : {}">
          <div class="row" *ngIf="!caseenable">
            <div class="col-lg-5">
              <label>Assign Case Manager<sup class="super-script">*</sup></label>
            </div>
            <div class="col-lg-7">
              <ng-select [(ngModel)]="assignCase.caseManagerId" [clearable]="false" [searchable]="true"
                [items]="CaseManagerDropdownList" bindLabel="Value" bindValue="Key">
              </ng-select>
            </div>
          </div>
          <div class="row" *ngIf="!caseenable">
            <div class="col-lg-5">
              <label>Start Date<sup class="super-script ">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-7">
              <my-date-picker [selDate]="assignCase.activeDate" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                (inputFieldChanged)="newdates($event,'inputchange','ActiveDate')"
                (dateChanged)="newdates($event,'datechanged','ActiveDate')">
              </my-date-picker>
            </div>
          </div>
          <div class="row" *ngIf="!caseenable">
            <div class="col-lg-5">
              <label class="labelpad">End Date</label>
            </div>
            <div class="col-lg-7">
              <my-date-picker [selDate]="assignCase.inActiveDate" [options]="myDatePickerOptions"
                placeholder="mm/dd/yyyy" (inputFieldChanged)="newdates($event,'inputchange','InActiveDate')"
                [disabled]="assignCase.activeDate==null||assignCase.activeDate==undefined||assignCase.activeDate==''"
                (dateChanged)="newdates($event,'datechanged','InActiveDate')">
              </my-date-picker>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-12">
              <app-case-manager *ngIf="caseenable" (emitcasemanger)="evenfromcase($event)" [fromClient]="casetype">
              </app-case-manager>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" (click)="AssignCase()" id="AssignCase"
            [disabled]="assignCase.caseManagerId == '00000000-0000-0000-0000-000000000000'|| this.assignCase.caseManagerId==undefined||this.assignCase.caseManagerId==null||this.assignCase.caseManagerId==0||this.assignCase.activeDate==undefined||this.assignCase.activeDate==null||this.assignCase.activeDate==''"
            *ngIf="!(this.assignCase.id!=undefined&&this.assignCase.id!=null&&assignCase.id != '00000000-0000-0000-0000-000000000000')&&!caseenable">
            Assign
          </button>
          <button type="button" class="btn btn-sm btn-primary" id="updateCase"
            *ngIf="!caseenable&&this.assignCase.id!=undefined&&this.assignCase.id!=null&&assignCase.id != '00000000-0000-0000-0000-000000000000'"
            [disabled]="(this.assignCase.caseManagerId==undefined||this.assignCase.caseManagerId==null||this.assignCase.caseManagerId==0||assignCase.caseManagerId == '00000000-0000-0000-0000-000000000000'||this.assignCase.activeDate==undefined||this.assignCase.activeDate==null||this.assignCase.activeDate=='')"
            (click)="AssignCase()">
            Update
          </button>
          <button type="button" class="btn btn-sm btn-secondary" id="closeCase"
            (click)="caseenable = false; closecase()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--------------- delete case manager------------------ -->

  <span id="deletecasemanger" data-bs-toggle="modal" data-bs-target="#deletecase"></span>
  <div class="modal hide fade modalbackgrod" id="deletecase" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog  ">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" id="deleteCaseicon"></button>
        </div>
        <div class="modal-body ">
          Do you want to delete this record ?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" (click)="deleteCase()" id="deleteCase">Yes</button>
          <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="deleteCaseno">No</button>
        </div>
      </div>
    </div>
  </div>


  <!-------------------------------------------Delete care coordinator------------------------------------------------------------>
  <span id="deletecarecoordinator" data-bs-toggle="modal" data-bs-target="#deletecare"></span>
  <div class="modal hide fade modalbackgrod" id="deletecare" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog ">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" id="deleterecord"></button>

        </div>
        <div class="modal-body ">
          Do you want to delete this record ?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" (click)="deleteCeare()" id="deleteCeare">Yes</button>

          <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="deleteCeareno">No</button>
        </div>
      </div>
    </div>
  </div>
 <!-- delete fms agency -->
    <span id="deletefmsagency" data-bs-toggle="modal" data-bs-target="#deletefms"></span>
  <div class="modal hide fade modalbackgrod" id="deletefms" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog ">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" id="deleterecordicn"></button>

        </div>
        <div class="modal-body ">
          Do you want to delete this record ?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" (click)="deletefmsagency()" id="deletefmsyes">Yes</button>

          <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="deletefmseno">No</button>
        </div>
      </div>
    </div>
  </div>
  <!------------------care coordinator---------------------------------------------------------------------->
  <span id="Careopen" data-bs-toggle="modal" data-bs-target="#carecoordinator"></span>
  <div class="modal hide fade modalbackgrod" id="carecoordinator" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" [ngClass]="{'modal-xl': careenable, '': !careenable}">
      <div class="modal-content">
        <div class="modal-header">

          <h5 class="modal-title font-header" id="exampleModalLabel" style="font-weight: 700;">Care Coordinator</h5>
          <button type="button" class="btn-close" (click)="closecarecoordinator();careenable=false;"
            id="closecarecoordinator"></button>

        </div>

        <div class="modal-body ml-1" [ngStyle]="careenable==true?{'height': '450px','overflow-y': 'auto'}:{}">
          <div class="row" *ngIf="!careenable">
            <div class="col-lg-5">
              <label style="font-weight: 530;">Assign Care Coordinator<sup class="super-script">*</sup></label>

            </div>
            <div class="col-lg-7">
              <ng-select [(ngModel)]="assignCare.careCoordinatorId" [clearable]="false" [searchable]="true"
                [items]="CareCoordinatorDropdownList" bindLabel="Value" bindValue="Key">
              </ng-select>
            </div>
          </div>
          <div class="row" *ngIf="!careenable">
            <div class="col-lg-5">
              <label>Start Date<sup class="super-script ">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-7">
              <my-date-picker [selDate]="assignCare.activeDate" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                (inputFieldChanged)="newdates($event,'inputchange','CareActiveDate')"
                (dateChanged)="newdates($event,'datechanged','CareActiveDate')">
              </my-date-picker>
            </div>
          </div>
          <div class="row" *ngIf="!careenable">
            <div class="col-lg-5">
              <label class="labelpad">
                End Date
              </label>
            </div>
            <div class="col-lg-7">
              <my-date-picker [selDate]="assignCare.inActiveDate" [options]="myDatePickerOptions"
                placeholder="mm/dd/yyyy" (inputFieldChanged)="newdates($event,'inputchange','CareInActiveDate')"
                [disabled]="(assignCare.activeDate==null||assignCare.activeDate==undefined||assignCare.activeDate=='')"
                (dateChanged)="newdates($event,'datechanged','CareInActiveDate')">
              </my-date-picker>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <app-care-coordinator *ngIf="careenable" (emitcarecode)="evenfromcare($event)" [fromClient]="caretype">
              </app-care-coordinator>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" (click)="AssignCare()" id="AssignCare"
            [disabled]="(this.assignCare.careCoordinatorId==undefined||this.assignCare.careCoordinatorId==null||this.assignCare.careCoordinatorId==0||this.assignCare.activeDate==undefined||this.assignCare.activeDate==null||this.assignCare.activeDate=='')"
            *ngIf="!careenable&&!(this.assignCare?.id!=undefined&&this.assignCare?.id!=null&&this.assignCare?.id!=0)">Assign</button>
          <button type="button" class="btn btn-sm btn-primary" id="updateCare"
            *ngIf="!careenable&&this.assignCare?.id!=undefined&&this.assignCare?.id!=null&&this.assignCare?.id!=0"
            (click)="AssignCare()"
            [disabled]="(this.assignCare.careCoordinatorId==undefined||this.assignCare.careCoordinatorId==null||this.assignCare.careCoordinatorId==0||this.assignCare.activeDate==undefined||this.assignCare.activeDate==null||this.assignCare.activeDate=='')">Update</button>

          <button type="button" class="btn btn-sm btn-primary" (click)="careenable=false;" id="closeCare"
            data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <!-- fms agency -->
  <span id="FMSagencyopen" data-bs-toggle="modal" data-bs-target="#fmsagency"></span>
  <div class="modal hide fade modalbackgrod" id="fmsagency" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" [ngClass]="{'modal-xl': fmsagencyenable, '': !fmsagencyenable}">
      <div class="modal-content">
        <div class="modal-header">

          <h5 class="modal-title font-header" id="exampleModalLabel" style="font-weight: 700;">FMS Agency</h5>
          <button type="button" class="btn-close" (click)="closefmsagency();fmsagencyenable=false;"
            id="closefmsagency"></button>

        </div>

        <div class="modal-body ml-1" [ngStyle]="fmsagencyenable==true?{'height': '450px','overflow-y': 'auto'}:{}">
          <div class="row" *ngIf="!fmsagencyenable">
            <div class="col-lg-5">
              <label style="font-weight: 530;">Assign FMS Agency<sup class="super-script">*</sup></label>

            </div>
            <div class="col-lg-7">
              <ng-select [(ngModel)]="assignfms.fmsagencyId" [clearable]="false" [searchable]="true"
                [items]="FMSAgencyDropdownList" bindLabel="Value" bindValue="Key">
              </ng-select>
            </div>
          </div>
          <div class="row" *ngIf="!fmsagencyenable">
            <div class="col-lg-5">
              <label>Start Date<sup class="super-script ">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-7">
              <my-date-picker [selDate]="assignfms.activeDate" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                (inputFieldChanged)="newdates($event,'inputchange','fmsagencyActiveDate')"
                (dateChanged)="newdates($event,'datechanged','fmsagencyActiveDate')">
              </my-date-picker>
            </div>
          </div>
          <div class="row" *ngIf="!fmsagencyenable">
            <div class="col-lg-5">
              <label class="labelpad">
                End Date
              </label>
            </div>
            <div class="col-lg-7">
              <my-date-picker [selDate]="assignfms.inActiveDate" [options]="myDatePickerOptions"
                placeholder="mm/dd/yyyy" (inputFieldChanged)="newdates($event,'inputchange','fmsagencyInActiveDate')"
                [disabled]="(assignfms.activeDate==null||assignfms.activeDate==undefined||assignfms.activeDate=='')"
                (dateChanged)="newdates($event,'datechanged','fmsagencyInActiveDate')">
              </my-date-picker>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <app-fms-agency *ngIf="fmsagencyenable" (emitcarecode)="emitfmsagency($event)"
                [fromClient]="fmsagencytype">
              </app-fms-agency>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" (click)="AssignFMSAgency()" id="AssigFMSAgency"
            [disabled]="(this.assignfms.fmsagencyId==undefined||this.assignfms.fmsagencyId==null||this.assignfms.fmsagencyId==0||this.assignfms.activeDate==undefined||this.assignfms.activeDate==null||this.assignfms.activeDate=='')"
            *ngIf="!fmsagencyenable&&!(this.assignfms?.id!=undefined&&this.assignfms?.id!=null&&this.assignfms?.id!=0)">Assign</button>
          <button type="button" class="btn btn-sm btn-primary" id="updateCare"
            *ngIf="!fmsagencyenable&&this.assignfms?.id!=undefined&&this.assignfms?.id!=null&&this.assignfms?.id!=0"
            (click)="AssignFMSAgency()"
            [disabled]="(this.assignfms.fmsagencyId==undefined||this.assignfms.fmsagencyId==null||this.assignfms.fmsagencyId==0||this.assignfms.activeDate==undefined||this.assignfms.activeDate==null||this.assignfms.activeDate=='')">Update</button>

          <button type="button" class="btn btn-sm btn-primary" (click)="fmsagencyenable=false;" id="closefms"
            data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <!-- showOfficeCaseManagerDetails -->
  <div class="modal fade" id="showOfficeCaseManagerDetails" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Case Manager Details</h5> <button type="button"
            class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title font-header">Name:</label> </div>
            <div class="col-lg-7"> <label>{{ OfficeCaseManagerinfo.name }}</label> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title font-header">Email:</label> </div>
            <div class="col-lg-7"> <label>{{ OfficeCaseManagerinfo.email }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title font-header">Phone:</label> </div>
            <div class="col-lg-7"> <label>{{ OfficeCaseManagerinfo.phone }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title font-header">Fax:</label> </div>
            <div class="col-lg-7"> <label>{{ OfficeCaseManagerinfo.fax }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title font-header">Alternate Fax:</label> </div>
            <div class="col-lg-7"> <label>{{ OfficeCaseManagerinfo.alternate_Fax }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title font-header">County:</label> </div>
            <div class="col-lg-7"> <label>{{ OfficeCaseManagerinfo.county }}</label><br> </div>
          </div>
          <!-- <div class="row">
            <div class="col-lg-4"> <label class="modal-title font-header">Active Date:</label> </div>
            <div class="col-lg-7"> <label>{{ OfficeCaseManagerinfo.activeDate }}</label><br> </div>
          </div> -->
        </div>
        <div class="modal-footer"> <button type="button" class="btn blue-btn" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="showCareCoordinatorDetails" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Care Coordinator Details</h5> <button type="button"
            class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Name:</label> </div>
            <div class="col-lg-7"> <label>{{ CareCoordinatorinfo.coordinator_Name }}</label> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Email:</label> </div>
            <div class="col-lg-7"> <label>{{ CareCoordinatorinfo.email }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Phone:</label> </div>
            <div class="col-lg-7"> <label>{{ CareCoordinatorinfo.phoneNumber }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Fax:</label> </div>
            <div class="col-lg-7"> <label>{{ CareCoordinatorinfo.fax }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Alternate Fax:</label> </div>
            <div class="col-lg-7"> <label>{{ CareCoordinatorinfo.alternateFax }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">County:</label> </div>
            <div class="col-lg-7"> <label>{{ CareCoordinatorinfo.county }}</label><br> </div>
          </div>
          <!-- <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Active Date:</label> </div>
            <div class="col-lg-7"> <label>{{ CareCoordinatorinfo.activeDate }}</label><br> </div>
          </div> -->
        </div>
        <div class="modal-footer"> <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

<div class="modal fade" id="showfmsagencyDetails" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">FMS Agency Details</h5> <button type="button"
            class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Name:</label> </div>
            <div class="col-lg-7"> <label>{{ FMSAgencyinfo.providerName }}</label> </div>
          </div>
           <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Address:</label> </div>
            <div class="col-lg-7"> <label>{{ FMSAgencyinfo.address }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">City:</label> </div>
            <div class="col-lg-7"> <label>{{ FMSAgencyinfo.city }}</label><br> </div>
          </div>
            <div class="row">
            <div class="col-lg-4"> <label class="modal-title">State:</label> </div>
            <div class="col-lg-7"> <label>{{ FMSAgencyinfo.state }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">ZipCode:</label> </div>
            <div class="col-lg-7"> <label>{{ FMSAgencyinfo.zipCode }}</label><br> </div>
          </div>
           <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Npi:</label> </div>
            <div class="col-lg-7"> <label>{{ FMSAgencyinfo.npi }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">ContactName:</label> </div>
            <div class="col-lg-7"> <label>{{ FMSAgencyinfo.contactName }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Email:</label> </div>
            <div class="col-lg-7"> <label>{{ FMSAgencyinfo.email }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Phone:</label> </div>
            <div class="col-lg-7"> <label>{{ FMSAgencyinfo.phoneNumber }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Fax:</label> </div>
            <div class="col-lg-7"> <label>{{ FMSAgencyinfo.fax }}</label><br> </div>
          </div>
          <!-- <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Active Date:</label> </div>
            <div class="col-lg-7"> <label>{{ CareCoordinatorinfo.activeDate }}</label><br> </div>
          </div> -->
        </div>
        <div class="modal-footer"> <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="showhhaagencyDetails" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Home Health Agency Details</h5> <button type="button"
            class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Name:</label> </div>
            <div class="col-lg-7"> <label>{{ HHAAgencyinfo.hhaName }}</label> </div>
          </div>
           <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Address:</label> </div>
            <div class="col-lg-7"> <label>{{ HHAAgencyinfo.address }}</label><br> </div>
          </div>
             <div class="row">
            <div class="col-lg-4"> <label class="modal-title">APT:</label> </div>
            <div class="col-lg-7"> <label>{{ HHAAgencyinfo.apt }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">City:</label> </div>
            <div class="col-lg-7"> <label>{{ HHAAgencyinfo.city }}</label><br> </div>
          </div>
            <div class="row">
            <div class="col-lg-4"> <label class="modal-title">State:</label> </div>
            <div class="col-lg-7"> <label>{{ HHAAgencyinfo.state }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">ZipCode:</label> </div>
            <div class="col-lg-7"> <label>{{ HHAAgencyinfo.zipCode }}</label><br> </div>
          </div>
        
         
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Email:</label> </div>
            <div class="col-lg-7"> <label>{{ HHAAgencyinfo.email }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Phone:</label> </div>
            <div class="col-lg-7"> <label>{{ HHAAgencyinfo.phoneNumber }}</label><br> </div>
          </div>
          <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Fax:</label> </div>
            <div class="col-lg-7"> <label>{{ HHAAgencyinfo.fax }}</label><br> </div>
          </div>
          <!-- <div class="row">
            <div class="col-lg-4"> <label class="modal-title">Active Date:</label> </div>
            <div class="col-lg-7"> <label>{{ CareCoordinatorinfo.activeDate }}</label><br> </div>
          </div> -->
        </div>
        <div class="modal-footer"> <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <!-- showQPHistoryDetails -->
  <div class="modal fade" id="showQPHistoryDetails" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">QP History Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            id="ClientEditQPHistoryDetailsicon"></button>
        </div>
        <div class="modal-body">
          <div class="row mb-2">
            <div class="col-lg-4">
              <label class="modal-title font-header">Name:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ QPHistoryinfo.name }}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-4">
              <label class="modal-title font-header">Status:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ QPHistoryinfo.currentStatus }}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-4">
              <label class="modal-title font-header">Last Modified Date:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ QPHistoryinfo?.lastModifiedDate | date: 'MM/dd/yyyy' }}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-4">
              <label class="modal-title font-header">Last Modified By:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ QPHistoryinfo.lastModifiedBy }}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-4">
              <label class="modal-title font-header">Mapped By:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ QPHistoryinfo.mappedBy }}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-4">
              <label class="modal-title font-header">Mapped On:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ QPHistoryinfo?.mappedOn | date: 'MM/dd/yyyy' }}</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
            id="ClientEditQPHistoryDetailscls">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- showQpDetails -->
  <div class="modal fade" id="showQpDetails" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Employee Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            id="ClientEditQPDetailsicon"></button>
        </div>
        <div class="modal-body">
          <div class="row mb-2">
            <div class="col-lg-3">
              <label class="modal-title font-header">Name:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ qpinfo.name }}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-3">
              <label class="modal-title font-header">Age:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ qpinfo.age }}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-3">
              <label class="modal-title font-header">Address:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ qpinfo.street }} {{ qpinfo.apt }}</label><br>
              <label>{{ qpinfo.city }}</label><br>
              <label>{{ qpinfo.street }} {{ qpinfo.zipcode }}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-3">
              <label class="modal-title font-header">Email:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ qpinfo.email }}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-3">
              <label class="modal-title font-header">Phone:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ qpinfo.phone1 }}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-3">
              <label class="modal-title font-header">Active Date:</label>
            </div>
            <div class="col-lg-7">
              <label>{{ qpinfo?.activeDate }}</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
            id="ClientEditQPDetailsbtn">Close</button>
        </div>
      </div>
    </div>
  </div>


  <!--==================================Add and Edit certificate=========================================-->
  <app-client-certificate-edit *ngIf="Editcert" [certificate]="EditCertificateoption"
    (DatafromCertificate)="dataEmitFromCertificate($event)"></app-client-certificate-edit>


  <span id="openSearchAddressModal" data-bs-target="#SearchAddress" data-bs-toggle="modal">
  </span>
  <div class="modal fade" id="SearchAddress" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="font-header">
            Search Address</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="AddressGoogleMap=false;"
            id="AddressGoogleMap"></button>
        </div>
        <div class="modal-body" style="min-height: 100px;">
          <div class="row">
            <div class="col-lg-12">
              <app-google-map *ngIf="AddressGoogleMap==true"
                (GoogleMapEmit)="EmitGoogleMapComponent($event)"></app-google-map>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm" data-bs-dismiss="modal" id="AddressGoogleMapbtn"
            (click)="AddressGoogleMap=false">Close</button>
        </div>
      </div>
    </div>
  </div>


  <!--PR Modal -->
  <!-- <span id="openWarningModal" data-bs-toggle="modal" data-bs-target="#warningModal"> </span> -->

<div class="modal fade"
     id="warningModal"
     tabindex="-1"
     aria-hidden="true"
     data-bs-backdrop="static"
     data-bs-keyboard="false">

  <div class="modal-dialog modal-md">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title text-warning">Warning</h5>
        <button type="button"
                class="btn-close"
                (click)="closeWarningModal()"
                aria-label="Close">
        </button>
      </div>

      <div class="modal-body">
        <span class="fw-bold">
          Participant’s Representative is Required..!!
        </span>
      </div>

      <div class="modal-footer">
        <button type="button"
                class="btn btn-secondary"
                (click)="closeWarningModal()">
          Close
        </button>
      </div>

    </div>
  </div>
</div>


  <!-- Home Health Agency -->
  <span id="HHAagencyopen" data-bs-toggle="modal" data-bs-target="#hhaagency"></span>
  <div class="modal hide fade modalbackgrod" id="hhaagency" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" [ngClass]="{'modal-xl': hhaagencyenable, '': !hhaagencyenable}">
      <div class="modal-content">
        <div class="modal-header">

          <h5 class="modal-title font-header" id="exampleModalLabel" style="font-weight: 700;">Home Health Agency</h5>
          <button type="button" class="btn-close" (click)="closehhaagency();hhaagencyenable=false;"
            id="closehhaagency"></button>

        </div>

        <div class="modal-body ml-1" [ngStyle]="hhaagencyenable==true?{'height': '450px','overflow-y': 'auto'}:{}">
          <div class="row" *ngIf="!hhaagencyenable">
            <div class="col-lg-5">
              <label style="font-weight: 530;">Assign Home Health Agency<sup class="super-script">*</sup></label>

            </div>
            <div class="col-lg-7">
              <ng-select [(ngModel)]="assignhha.hhAgencyId" [clearable]="false" [searchable]="true"
                [items]="HHAAgencyDropdownList" bindLabel="Value" bindValue="Key">
              </ng-select>
            </div>
          </div>
          <div class="row" *ngIf="!hhaagencyenable">
            <div class="col-lg-5">
              <label>Start Date<sup class="super-script ">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-7">
              <my-date-picker [selDate]="assignhha.activeDate" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                (inputFieldChanged)="newdates($event,'inputchange','hhaagencyActiveDate')"
                (dateChanged)="newdates($event,'datechanged','hhaagencyActiveDate')">
              </my-date-picker>
            </div>
          </div>
          <div class="row" *ngIf="!hhaagencyenable">
            <div class="col-lg-5">
              <label class="labelpad">
                End Date
              </label>
            </div>
            <div class="col-lg-7">
              <my-date-picker [selDate]="assignhha.inActiveDate" [options]="myDatePickerOptions"
                placeholder="mm/dd/yyyy" (inputFieldChanged)="newdates($event,'inputchange','hhaagencyInActiveDate')"
                [disabled]="(assignhha.activeDate==null||assignhha.activeDate==undefined||assignhha.activeDate=='')"
                (dateChanged)="newdates($event,'datechanged','hhaagencyInActiveDate')">
              </my-date-picker>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <app-home-health-agency *ngIf="hhaagencyenable" (emitcarecode)="emithhaagency($event)"
                [fromClient]="hhaagencytype">
              </app-home-health-agency>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" (click)="AssignHHAAgency()" id="AssigHHAAgency"
            [disabled]="(this.assignhha.hhAgencyId==undefined||this.assignhha.hhAgencyId==null||this.assignhha.hhAgencyId==0||this.assignhha.activeDate==undefined||this.assignhha.activeDate==null||this.assignhha.activeDate=='')"
            *ngIf="!hhaagencyenable&&!(this.assignhha?.id!=undefined&&this.assignhha?.id!=null&&this.assignhha?.id!=0)">Assign</button>
          <button type="button" class="btn btn-sm btn-primary" id="updateCare"
            *ngIf="!hhaagencyenable&&this.assignhha?.id!=undefined&&this.assignhha?.id!=null&&this.assignhha?.id!=0"
            (click)="AssignHHAAgency()"
            [disabled]="(this.assignhha.hhAgencyId==undefined||this.assignhha.hhAgencyId==null||this.assignhha.hhAgencyId==0||this.assignhha.activeDate==undefined||this.assignhha.activeDate==null||this.assignhha.activeDate=='')">Update</button>

          <button type="button" class="btn btn-sm btn-primary" (click)="hhaagencyenable=false;" id="closehha"
            data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <!-- CLIENT EMPLOYEE MAPPING BUTTON - Add after line 3265 -->
<!-- <div class="row mb-2" *ngIf="!DataFromList.newclient">
  <div class="col p-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body">
        <button 
          type="button" 
          class="btn btn-primary btn-sm" 
          (click)="openClientEmployeeMapping()"
          data-bs-toggle="modal" 
          data-bs-target="#clientEmployeeMappingModal"
          [disabled]="!ClientList.id || ClientList.id === '00000000-0000-0000-0000-000000000000'">
          <i class="fa fa-users"></i> Client Employee Mapping
        </button>
      </div>
    </div>
  </div>
</div> -->

<app-qp-info 
          *ngIf="showQpInfoComponent"
          [preSelectedClientId]="ClientList.id"
          [openedFromClientPage]="true"
           (employeeMappingSaved)="closeClientEmployeeMapping()">
        </app-qp-info>

   <span id="deletehhaagency" data-bs-toggle="modal" data-bs-target="#deletehha"></span>
  <div class="modal hide fade modalbackgrod" id="deletehha" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog ">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" id="deleterecordicn"></button>

        </div>
        <div class="modal-body ">
          Do you want to delete this record ?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" (click)="deletehhaagency()" id="deletehhayes">Yes</button>

          <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal" id="deletehhaeno">No</button>
        </div>
      </div>
    </div>
  </div>
  <!--Eligibility Warning Modal -->
<!-- <span id="openEligibilityWarningModal" data-bs-toggle="modal" data-bs-target="#eligibilityWarningModal"> </span> -->

<div class="modal fade"
     id="eligibilityWarningModal"
     tabindex="-1"
     aria-hidden="true"
     data-bs-backdrop="static"
     data-bs-keyboard="false">

  <div class="modal-dialog modal-md">
    <div class="modal-content">

      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title">Warning</h5>
        <button type="button"
                class="btn-close btn-close-white"
                (click)="closeEligibilityWarningModal()">
        </button>
      </div>

      <div class="modal-body">
        <span class="fw-bold text-danger">
          Participant does not have valid eligibility..!!
        </span>
      </div>

      <div class="modal-footer">
        <button type="button"
                class="btn btn-danger"
                (click)="closeEligibilityWarningModal()">
          Close
        </button>
      </div>

    </div>
  </div>
</div>

</div>
